import _assertThisInitialized from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _inherits from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e18) { throw _e18; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e19) { didErr = true; err = _e19; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var e = ["web", "wxwv", "minp", "alip", "baidup", "qq", "bytedance"],
  t = {
    autotrack: {
      type: "boolean",
      default: !0
    },
    compress: {
      type: "boolean",
      default: !0
    },
    dataCollect: {
      type: "boolean",
      default: !0
    },
    debug: {
      type: "boolean",
      default: !1
    },
    hashtag: {
      type: "boolean",
      default: !1
    },
    touch: {
      type: "boolean",
      default: !1
    },
    version: {
      type: "string",
      default: "1.0.0"
    },
    platform: {
      type: "string",
      default: "web"
    },
    cookieDomain: {
      type: "string",
      default: ""
    }
  },
  i = {
    enableIdMapping: {
      type: "boolean",
      default: !1
    },
    gtouchHost: {
      type: "string",
      default: ""
    },
    host: {
      type: "string",
      default: "napi.growingio.com"
    },
    ignoreFields: {
      type: "array",
      default: []
    },
    penetrateHybrid: {
      type: "boolean",
      default: !0
    },
    scheme: {
      type: "string",
      default: location.protocol.indexOf("http") > -1 ? location.protocol.replace(":", "") : "https"
    },
    sessionExpires: {
      type: "number",
      default: 30
    },
    performance: {
      type: "object",
      default: {
        monitor: !0,
        exception: !0
      }
    },
    embeddedIgnore: {
      type: "array",
      default: []
    },
    storageType: {
      type: "string",
      default: "cookie"
    }
  },
  n = {},
  r = ["clearUserId", "getGioInfo", "getLocation", "getOption", "init", "setDataCollect", "setOption", "setUserId", "track", "setGeneralProps", "clearGeneralProps", "enableDebug", "enableHT", "setAutotrack", "setTrackerHost", "setTrackerScheme", "setUserAttributes", "getVisitorId", "getDeviceId", "registerPlugins", "getPlugins", "sendPage", "sendVisit", "trackTimerStart", "trackTimerPause", "trackTimerResume", "trackTimerEnd", "removeTimer", "clearTrackTimer"],
  s = ["autotrack", "dataCollect", "dataSourceId", "debug", "host", "hashtag", "scheme"],
  o = {
    autotrack: "无埋点采集",
    dataCollect: "数据采集",
    debug: "调试模式"
  },
  a = ["send", "setConfig", "collectImp", "setPlatformProfile"],
  d = ["screenHeight", "screenWidth"],
  c = {
    click: "VIEW_CLICK",
    change: "VIEW_CHANGE",
    submit: "FORM_SUBMIT"
  };
var l,
  h,
  u,
  g,
  p,
  f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  m = "function" == typeof Array.from ? Array.from : (h || (h = 1, u = function u(e) {
    return "function" == typeof e;
  }, g = function g(e) {
    var t = function (e) {
      var t = Number(e);
      return isNaN(t) ? 0 : 0 !== t && isFinite(t) ? (t > 0 ? 1 : -1) * Math.floor(Math.abs(t)) : t;
    }(e);
    return Math.min(Math.max(t, 0), 9007199254740991);
  }, p = function p(e) {
    var t = e.next();
    return !t.done && t;
  }, l = function l(e) {
    var t,
      i,
      n,
      r = this,
      s = arguments.length > 1 ? arguments[1] : void 0;
    if (void 0 !== s) {
      if (!u(s)) throw new TypeError("Array.from: when provided, the second argument must be a function");
      arguments.length > 2 && (t = arguments[2]);
    }
    var o = function (e, t) {
      if (null != e && null != t) {
        var i = e[t];
        if (null == i) return;
        if (!u(i)) throw new TypeError(i + " is not a function");
        return i;
      }
    }(e, function (e) {
      if (null != e) {
        if (["string", "number", "boolean", "symbol"].indexOf(typeof e) > -1) return Symbol.iterator;
        if ("undefined" != typeof Symbol && "iterator" in Symbol && Symbol.iterator in e) return Symbol.iterator;
        if ("@@iterator" in e) return "@@iterator";
      }
    }(e));
    if (void 0 !== o) {
      i = u(r) ? Object(new r()) : [];
      var a,
        d,
        c = o.call(e);
      if (null == c) throw new TypeError("Array.from requires an array-like or iterable object");
      for (n = 0;;) {
        if (!(a = p(c))) return i.length = n, i;
        d = a.value, i[n] = s ? s.call(t, d, n) : d, n++;
      }
    } else {
      var l = Object(e);
      if (null == e) throw new TypeError("Array.from requires an array-like object - not null or undefined");
      var h,
        f = g(l.length);
      for (i = u(r) ? Object(new r(f)) : Array(f), n = 0; f > n;) {
        h = l[n], i[n] = s ? s.call(t, h, n) : h, n++;
      }
      i.length = f;
    }
    return i;
  }), l);
var v = function v(e) {
    return R(["undefined", "null"], $(e));
  },
  I = function I(e) {
    return "string" === $(e);
  },
  w = function w(e) {
    return "number" === $(e);
  },
  O = function O(e) {
    return "NaN" === k(Number(e));
  },
  b = function b(e) {
    return "boolean" === $(e);
  },
  y = function y(e) {
    return "object" === $(e) && !v(e);
  },
  E = function E(e) {
    return "regexp" === $(e);
  },
  _ = function _(e) {
    return "function" === $(e);
  },
  S = function S(e) {
    return Array.isArray(e) && "array" === $(e);
  },
  T = function T(e) {
    return "date" === $(e);
  },
  N = function N(e) {
    try {
      return L(e)[0];
    } catch (e) {
      return;
    }
  },
  C = function C(e) {
    try {
      var _t2 = L(e);
      return _t2[_t2.length - 1];
    } catch (e) {
      return;
    }
  },
  x = function x(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return S(e) && w(t) ? e.slice(t > 0 ? t : 1, e.length) : e;
  },
  A = function A(e) {
    if (S(e)) {
      var _t3 = 0;
      var _i = [];
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _n = _step.value;
          _n && !F(_n) && (_i[_t3++] = _n);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return _i;
    }
    return e;
  },
  P = function P(e, t) {
    return e[D(e, t)];
  },
  D = function D(e, t) {
    var i = -1;
    return S(e) && e.every(function (e, n) {
      return !t(e) || (i = n, !1);
    }), i;
  },
  R = function R(e, t) {
    return ("array" === $(e) || "string" === $(e)) && e.indexOf(t) >= 0;
  },
  L = m,
  k = function k(e) {
    return v(e) ? "" : "" + e;
  },
  U = function U(e, t) {
    return "string" == typeof e ? e.split(t) : e;
  },
  j = function j(e) {
    if (I(e)) {
      var _t4 = U(e, "");
      return "".concat(N(_t4).toLowerCase()).concat(x(_t4).join(""));
    }
    return e;
  },
  G = function G(e, t) {
    return !!I(e) && e.slice(0, t.length) === t;
  },
  q = function q(e, t) {
    if (I(e)) {
      var _i2 = e.length;
      var _n2 = _i2;
      _n2 > _i2 && (_n2 = _i2);
      var _r = _n2;
      return _n2 -= t.length, _n2 >= 0 && e.slice(_n2, _r) === t;
    }
    return !1;
  },
  H = {}.hasOwnProperty,
  B = function B(e, t) {
    return !v(e) && H.call(e, t);
  },
  K = function K(e) {
    return y(e) ? Object.keys(e) : [];
  },
  W = function W(e, t) {
    K(e).forEach(function (i) {
      return t(e[i], i);
    });
  },
  M = function M(e, t) {
    var i = K(e);
    return !(!y(e) || !y(t) || i.length !== K(t).length || R(i.map(function (i, n) {
      return y(e[i]) ? M(e[i], t[i]) : e[i] === t[i];
    }), !1));
  },
  V = function V(e, t) {
    if (!y(e)) return !1;
    try {
      return "string" === $(t) ? delete e[t] : "array" === $(t) ? t.map(function (t) {
        return delete e[t];
      }) : (E(t) && K(e).forEach(function (i) {
        t.test(i) && V(e, i);
      }), !0);
    } catch (e) {
      return !1;
    }
  },
  F = function F(e) {
    return S(e) ? 0 === e.length : y(e) ? 0 === K(e).length : !e;
  },
  $ = function $(e) {
    return {}.toString.call(e).slice(8, -1).toLowerCase();
  };
var X = Object.freeze({
  __proto__: null,
  isNil: v,
  isString: I,
  isNumber: w,
  isNaN: O,
  isBoolean: b,
  isObject: y,
  isRegExp: E,
  isFunction: _,
  isArray: S,
  isDate: T,
  fixed: function fixed(e, t) {
    return w(e) ? Number(e.toFixed(w(t) ? t : 2)) : I(e) && "NaN" !== k(Number(e)) ? Number(Number(e).toFixed(w(t) ? t : 2)) : e;
  },
  head: N,
  last: C,
  drop: x,
  dropWhile: function dropWhile(e, t) {
    return S(e) ? e.filter(function (e) {
      return !t(e);
    }) : e;
  },
  compact: A,
  find: P,
  findIndex: D,
  includes: R,
  arrayFrom: L,
  toString: k,
  split: U,
  lowerFirst: j,
  upperFirst: function upperFirst(e) {
    if (I(e)) {
      var _t5 = U(e, "");
      return "".concat(N(_t5).toUpperCase()).concat(x(_t5).join(""));
    }
    return e;
  },
  startsWith: G,
  endsWith: q,
  hasOwnProperty: H,
  has: B,
  keys: K,
  forEach: W,
  isEqual: M,
  get: function get(e, t, i) {
    var n = e;
    return y(e) ? (t.split(".").forEach(function (e) {
      n = n ? n[e] : i;
    }), n) : i;
  },
  unset: V,
  isEmpty: F,
  typeOf: $,
  formatDate: function formatDate(e) {
    if (T(e)) {
      var _t6 = function _t6(e) {
        return 10 > e ? "0" + e : e;
      };
      return e.getFullYear() + "-" + _t6(e.getMonth() + 1) + "-" + _t6(e.getDate()) + " " + _t6(e.getHours()) + ":" + _t6(e.getMinutes()) + ":" + _t6(e.getSeconds()) + "." + _t6(e.getMilliseconds());
    }
    return e;
  }
});
var z = function z(e, t) {
    console.log("%c [GrowingIO]：" + e, {
      info: "color: #3B82F6;",
      error: "color: #EF4444;",
      warn: "color: #F59E0B;",
      success: "color: #10B981;"
    }[t] || "");
  },
  J = function J(e) {
    try {
      return e();
    } catch (e) {
      return;
    }
  },
  Z = function Z(e) {
    var t = {};
    return y(e) && W(e, function (e, i) {
      var n;
      var r = k(i).slice(0, 100);
      y(e) ? t[r] = Z(e) : S(e) ? (t[r] = e.slice(0, 100), "cdp" === (null === (n = window.vds) || void 0 === n ? void 0 : n.gioEnvironment) && (t[r] = t[r].join("||"))) : t[r] = v(e) ? "" : k(e).slice(0, 1e3);
    }), t;
  },
  Q = function Q(e, t, i) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    document.addEventListener ? e.addEventListener(t, i, Object.assign(Object.assign({}, {
      capture: !0
    }), n)) : e.attachEvent ? e.attachEvent("on" + t, i) : e["on" + t] = i;
  },
  Y = function Y(e, t) {
    return I(e) && !F(e) && e.match(/^[a-zA-Z_][0-9a-zA-Z_]{0,100}$/) ? t() : (z("事件名格式不正确，只能包含数字、字母和下划线，且不能以数字开头，字符总长度不能超过100!", "error"), !1);
  };
var ee = Object.freeze({
  __proto__: null,
  consoleText: z,
  niceTry: J,
  limitObject: Z,
  addListener: Q,
  flattenObject: function flattenObject() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = Object.assign({}, e);
    return K(t).forEach(function (e) {
      y(t[e]) ? (K(t[e]).forEach(function (i) {
        t["".concat(e, "_").concat(i)] = k(t[e][i]);
      }), V(t, e)) : S(t[e]) ? (t[e].forEach(function (i, n) {
        y(i) ? K(i).forEach(function (r) {
          t["".concat(e, "_").concat(n, "_").concat(r)] = k(i[r]);
        }) : t["".concat(e, "_").concat(n)] = k(i);
      }), V(t, e)) : v(t[e]) || "" === t[e] ? V(t, e) : t[e] = k(t[e]);
    }), t;
  },
  eventNameValidate: Y
});
var te = function te(e) {
    return I(e) && e.length > 0 || w(e) && e > 0;
  },
  ie = /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/i,
  ne = /^(https?:\/\/)|(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;
function re(e) {
  for (var t = 1; arguments.length > t; t++) {
    var i = arguments[t];
    for (var n in i) {
      e[n] = i[n];
    }
  }
  return e;
}
var se = function e(t, i) {
  function n(e, n, r) {
    if ("undefined" != typeof document) {
      "number" == typeof (r = re({}, i, r)).expires && (r.expires = new Date(Date.now() + 864e5 * r.expires)), r.expires && (r.expires = r.expires.toUTCString()), e = encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var o in r) {
        r[o] && (s += "; " + o, !0 !== r[o] && (s += "=" + r[o].split(";")[0]));
      }
      return document.cookie = e + "=" + t.write(n, e) + s;
    }
  }
  return Object.create({
    set: n,
    get: function get(e) {
      if ("undefined" != typeof document && (!arguments.length || e)) {
        for (var i = document.cookie ? document.cookie.split("; ") : [], n = {}, r = 0; r < i.length; r++) {
          var s = i[r].split("="),
            o = s.slice(1).join("=");
          try {
            var a = decodeURIComponent(s[0]);
            if (n[a] = t.read(o, a), e === a) break;
          } catch (e) {}
        }
        return e ? n[e] : n;
      }
    },
    remove: function remove(e, t) {
      n(e, "", re({}, t, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(t) {
      return e(this.converter, re({}, this.attributes, t));
    },
    withConverter: function withConverter(t) {
      return e(re({}, this.converter, t), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(i)
    },
    converter: {
      value: Object.freeze(t)
    }
  });
}({
  read: function read(e) {
    return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
}, {
  path: "/"
});
var oe = function oe() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
      var t = 16 * Math.random() | 0;
      return ("x" === e ? t : 3 & t | 8).toString(16);
    });
  },
  ae = function ae() {
    var e;
    var t = !!(null === (e = null === window || void 0 === window ? void 0 : window.navigator) || void 0 === e ? void 0 : e.sendBeacon),
      i = window.navigator.userAgent;
    if (i.match(/(iPad|iPhone|iPod)/g)) {
      var _e2 = de(i);
      return t && _e2 > 13;
    }
    return t;
  },
  de = function de(e) {
    var t = e.toLowerCase().match(/cpu.*os (.*?) like mac os/i);
    return !t || 2 > t.length ? 0 : +t[1].split("_").slice(0, 2).join(".");
  },
  ce = function ce(e) {
    return q(e, "_gioenc") ? e.slice(0, -7) : e;
  },
  le = function le(e) {
    return O(Number(e)) && J(function () {
      return JSON.parse(e);
    }) || e;
  },
  he = {
    A: 1,
    a: 1,
    Z: 1,
    z: 1,
    "@": 1,
    "{": 1
  },
  ue = function ue(e) {
    return v(e) ? e : J(function () {
      return "gioenc-" + pe(e);
    }) || e;
  },
  ge = function ge(e) {
    return I(e) && G(e, "gioenc-") && J(function () {
      return pe(e.replace("gioenc-", ""));
    }) || e;
  },
  pe = function pe(e) {
    return (e = e || "").split("").map(function (e) {
      return he[e] ? e : fe(e);
    }).join("");
  },
  fe = function fe(e) {
    if (/[0-9]/.test(e)) return 1 ^ +e;
    {
      var _t7 = e.charCodeAt(0);
      return String.fromCharCode(1 ^ _t7);
    }
  };
var me = /*#__PURE__*/_createClass(function me(e) {
  var _this = this;
  _classCallCheck(this, me);
  this.domain = e, this.getItem = function (e) {
    return le(ge(se.get(ce(e), {
      domain: _this.domain,
      path: "/"
    })));
  }, this.setItem = function (e, t, i) {
    var n;
    n = I(t) ? t.length ? q(e, "_gioenc") ? ue(t) : t : "" : JSON.stringify(t), se.set(ce(e), n, {
      expires: i ? new Date(i) : 3650,
      domain: _this.domain,
      path: "/"
    });
  }, this.removeItem = function (e) {
    se.remove(ce(e), {
      domain: _this.domain,
      path: "/"
    });
  }, this.hasItem = function (e) {
    return R(K(se.get()), ce(e));
  }, this.getKeys = function () {
    return K(se.get());
  }, this.type = "Cookie";
});
var ve = /*#__PURE__*/_createClass(function ve() {
  _classCallCheck(this, ve);
  this.getItem = function (e) {
    var t = J(function () {
      return JSON.parse(localStorage.getItem(ce(e)) || "");
    }) || {};
    return y(t) && t.expiredAt > +Date.now() ? le(ge(t.value)) : void 0;
  }, this.setItem = function (e, t, i) {
    var n = null != i ? i : +new Date(9999, 12);
    localStorage.setItem(ce(e), JSON.stringify({
      value: I(t) && t.length && q(e, "_gioenc") ? ue(t) : t,
      expiredAt: n
    }));
  }, this.removeItem = function (e) {
    return localStorage.removeItem(ce(e));
  }, this.hasItem = function (e) {
    return !!localStorage.getItem(ce(e));
  }, this.getKeys = function () {
    return L(Array(localStorage.length)).map(function (e, t) {
      return localStorage.key(t);
    });
  }, this.type = "localStorage";
});
var Ie = {};
var we = /*#__PURE__*/_createClass(function we() {
  _classCallCheck(this, we);
  this.getItem = function (e) {
    var t = J(function () {
      return JSON.parse(Ie[ce(e)] || "");
    });
    return y(t) && t.expiredAt > +Date.now() ? le(ge(t.value)) : void 0;
  }, this.setItem = function (e, t, i) {
    var n = null != i ? i : +new Date(9999, 12);
    Ie[ce(e)] = JSON.stringify({
      value: I(t) && t.length ? ue(t) : t,
      expiredAt: n
    });
  }, this.removeItem = function (e) {
    return V(Ie, ce(e));
  }, this.hasItem = function (e) {
    return B(Ie, ce(e));
  }, this.getKeys = function () {
    return K(Ie);
  }, this.type = "memory";
});
var Oe;
var be = /^(\.ac\.|\.br\.|\.co\.|\.com\.|\.edu\.|\.gov\.|\.org\.|\.net\.)/,
  ye = function ye(e) {
    var t = [];
    try {
      var _i3 = e.split("."),
        _n3 = C(_i3);
      if (_i3.length >= 2 && (isNaN(Number(_n3)) || 0 > Number(_n3) || Number(_n3) > 255)) {
        var _e3 = "." + _i3.slice(-2).join(".");
        be.test(_e3) ? Oe = _e3 : t.push(_e3);
        var _n4 = "." + _i3.slice(-3).join(".");
        be.test(_n4) || t.includes(_n4) || t.push(_n4);
        var _r2 = "." + _i3.slice(-4).join(".");
        be.test(_r2) || t.includes(_r2) || t.push(_r2);
      }
    } catch (e) {}
    return t;
  },
  Ee = function Ee(e) {
    var t = "";
    return e.every(function (e) {
      return !_e(e) || (t = e, !1);
    }), t;
  },
  _e = function _e(e) {
    try {
      se.set("gioCookie", "yes", {
        domain: e
      });
      var _t8 = !!se.get("gioCookie", {
        domain: e
      });
      return se.remove("gioCookie", {
        domain: e
      }), _t8;
    } catch (e) {
      return !1;
    }
  },
  Se = function Se(e) {
    var t,
      i,
      n,
      r = e.storageType,
      s = e.cookieDomain,
      o = e.projectId;
    if (R(["cookie", "localstorage"], r) || (r = "cookie"), "cookie" === r && (n = navigator.userAgent.indexOf("Electron") > -1 || R(["", "localhost", "127.0.0.1"], window.location.hostname) || !R(["http:", "https:"], window.location.protocol) ? "" : Ee([].concat(_toConsumableArray(ye(window.location.hostname)), [window.location.hostname])), i = !!n), "cookie" === r && i) {
      var _e4 = new me(n);
      if (s) {
        var _t9 = ye(s);
        var _i4 = Ee(F(_t9) ? [] : [s].concat(_toConsumableArray(ye(s))));
        _i4 && _e(_i4) ? _e4.domain = _i4 : z("指定Cookie域无效或无权限，使用默认域！", "warn");
      }
      t = _e4;
    } else t = function () {
      try {
        var _e5 = window.localStorage,
          _t10 = "__storage_test__";
        return _e5.setItem(_t10, _t10), _e5.removeItem(_t10), !0;
      } catch (e) {
        return !1;
      }
    }() ? new ve() : new we();
    return "cookie" === r && Oe && _e(Oe) && function (e, t, i) {
      if (t && _e(t)) {
        var _n5 = new me(t);
        [i + "_gdp_session_id", "gdp_user_id_gioenc", i + "_gdp_cs1_gioenc", i + "_gdp_user_key_gioenc", i + "_gdp_gio_id_gioenc", i + "_gdp_sequence_ids", i + "_gdp_session_id_sent"].forEach(function (t) {
          var i = _n5.getItem(t);
          _n5.hasItem(t) && (e.setItem(t, i), _n5.removeItem(t));
        }), _n5 = void 0;
      }
    }(t, Oe, o), t;
  };
var Te = "OPTION_INITIALIZED",
  Ne = "SDK_INITIALIZED",
  Ce = "SESSIONID_UPDATE",
  xe = "SET_USERID",
  Ae = "SET_USERKEY",
  Pe = {
    name: "gioCompress",
    method: /*#__PURE__*/_createClass(function method(e) {
      var _this2 = this;
      _classCallCheck(this, method);
      this.growingIO = e, this._compress = function (e, t, i) {
        if (null === e) return "";
        var n,
          r,
          s,
          o = {},
          a = {},
          d = "",
          c = "",
          l = "",
          h = 2,
          u = 3,
          g = 2,
          p = [],
          f = 0,
          m = 0;
        for (s = 0; s < e.length; s += 1) {
          if (d = e.charAt(s), {}.hasOwnProperty.call(o, d) || (o[d] = u++, a[d] = !0), c = l + d, {}.hasOwnProperty.call(o, c)) l = c;else {
            if ({}.hasOwnProperty.call(a, l)) {
              if (256 > l.charCodeAt(0)) {
                for (n = 0; g > n; n++) {
                  f <<= 1, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++;
                }
                for (r = l.charCodeAt(0), n = 0; 8 > n; n++) {
                  f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
                }
              } else {
                for (r = 1, n = 0; g > n; n++) {
                  f = f << 1 | r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r = 0;
                }
                for (r = l.charCodeAt(0), n = 0; 16 > n; n++) {
                  f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
                }
              }
              h--, 0 === h && (h = Math.pow(2, g), g++), delete a[l];
            } else for (r = o[l], n = 0; g > n; n++) {
              f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
            }
            h--, 0 === h && (h = Math.pow(2, g), g++), o[c] = u++, l = d + "";
          }
        }
        if ("" !== l) {
          if ({}.hasOwnProperty.call(a, l)) {
            if (256 > l.charCodeAt(0)) {
              for (n = 0; g > n; n++) {
                f <<= 1, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++;
              }
              for (r = l.charCodeAt(0), n = 0; 8 > n; n++) {
                f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
              }
            } else {
              for (r = 1, n = 0; g > n; n++) {
                f = f << 1 | r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r = 0;
              }
              for (r = l.charCodeAt(0), n = 0; 16 > n; n++) {
                f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
              }
            }
            h--, 0 === h && (h = Math.pow(2, g), g++), delete a[l];
          } else for (r = o[l], n = 0; g > n; n++) {
            f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
          }
          h--, 0 === h && (h = Math.pow(2, g), g++);
        }
        for (r = 2, n = 0; g > n; n++) {
          f = f << 1 | 1 & r, m === t - 1 ? (m = 0, p.push(i(f)), f = 0) : m++, r >>= 1;
        }
        for (;;) {
          if (f <<= 1, m === t - 1) {
            p.push(i(f));
            break;
          }
          m++;
        }
        return p.join("");
      }, this.compress = function (e) {
        var t = _this2;
        return _this2._compress(e, 16, function (e) {
          return t.f(e);
        });
      }, this.compressToUTF16 = function (e) {
        var t = _this2;
        return null === e ? "" : _this2._compress(e, 15, function (e) {
          return t.f(e + 32);
        }) + " ";
      }, this.compressToUint8Array = function (e) {
        var t = _this2.compress(e),
          i = new Uint8Array(2 * t.length);
        for (var _e6 = 0, _n6 = t.length; _n6 > _e6; _e6++) {
          var _n7 = t.charCodeAt(_e6);
          i[2 * _e6] = _n7 >>> 8, i[2 * _e6 + 1] = _n7 % 256;
        }
        return i;
      }, this.compressToEncodedURIComponent = function (e) {
        return null == e ? "" : _this2._compress(e, 6, function (e) {
          return this.keyStrUriSafe.charAt(e);
        });
      }, this.f = String.fromCharCode, this.keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    })
  },
  De = {
    name: "gioCustomTracking",
    method: /*#__PURE__*/_createClass(function method(e) {
      var _this3 = this;
      _classCallCheck(this, method);
      this.growingIO = e, this.getValidResourceItem = function (e) {
        if (e && y(e) && e.id && e.key) {
          var _t11 = {
            id: I(e.id) ? e.id : k(e.id),
            key: I(e.key) ? e.key : k(e.key)
          };
          return e.attributes && (_t11.attributes = e.attributes), _t11;
        }
      }, this.getDynamicAttributes = function (e) {
        return v(e) || K(e).forEach(function (t) {
          _(e[t]) ? e[t] = e[t]() : y(e[t]) ? V(e, t) : S(e[t]) || (e[t] = k(e[t]));
        }), e;
      }, this.buildCustomEvent = function (e, t, i, n) {
        Y(e, function () {
          var _this3$growingIO$data = _this3.growingIO.dataStore,
            r = _this3$growingIO$data.eventContextBuilder,
            s = _this3$growingIO$data.eventConverter,
            o = _this3$growingIO$data.currentPage;
          var a = Object.assign({
            eventType: "CUSTOM",
            eventName: e,
            pageShowTimestamp: null == o ? void 0 : o.time,
            attributes: Z(_this3.getDynamicAttributes(y(t) && !F(t) ? t : void 0)),
            resourceItem: Z(_this3.getValidResourceItem(i))
          }, r());
          F(n) || (a = Object.assign(Object.assign({}, a), n)), s(a);
        });
      }, this.buildUserAttributesEvent = function (e, t) {
        var _this3$growingIO$data2 = _this3.growingIO.dataStore,
          i = _this3$growingIO$data2.eventContextBuilder,
          n = _this3$growingIO$data2.eventConverter;
        var r = Object.assign({
          eventType: "LOGIN_USER_ATTRIBUTES",
          attributes: Z(e)
        }, i());
        F(t) || (r = Object.assign(Object.assign({}, r), t)), n(r);
      };
    })
  },
  Re = {},
  Le = {}.hasOwnProperty;
function ke(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch (e) {
    return null;
  }
}
function Ue(e) {
  try {
    return encodeURIComponent(e);
  } catch (e) {
    return null;
  }
}
Re.stringify = function (e, t) {
  t = t || "";
  var i,
    n,
    r = [];
  for (n in "string" != typeof t && (t = "?"), e) {
    if (Le.call(e, n)) {
      if ((i = e[n]) || null != i && !isNaN(i) || (i = ""), n = Ue(n), i = Ue(i), null === n || null === i) continue;
      r.push(n + "=" + i);
    }
  }
  return r.length ? t + r.join("&") : "";
}, Re.parse = function (e) {
  for (var t, i = /([^=?#&]+)=?([^&]*)/g, n = {}; t = i.exec(e);) {
    var r = ke(t[1]),
      s = ke(t[2]);
    null === r || null === s || r in n || (n[r] = s);
  }
  return n;
};
var je = {
    gioprojectid: "projectId",
    giodatacollect: "dataCollect",
    gioappid: "domain",
    giodatasourceid: "dataSourceId",
    gios: "sessionId",
    giou: "uid",
    giocs1: "userId",
    gioid: "gioId",
    giouserkey: "userKey",
    gioappchannel: "appChannel",
    giodevicebrand: "deviceBrand",
    giodevicemodel: "deviceModel",
    giodevicetype: "deviceType",
    giolanguage: "language",
    gionetworkstate: "networkState",
    giooperatingsystem: "operatingSystem",
    gioplatform: "platform",
    gioplatformversion: "platformVersion",
    gioscreenheight: "screenHeight",
    gioscreenwidth: "screenWidth"
  },
  Ge = ["giodatasourceid", "gioplatform", "gioappchannel", "giodevicebrand", "giodevicemodel", "giodevicetype", "giolanguage", "gionetworkstate", "giooperatingsystem", "gioplatformversion", "gioscreenheight", "gioscreenwidth"],
  qe = ["giocs1", "gios", "giou", "gioid", "giouserkey"],
  He = "gio_search_cookie_gioenc";
var Be,
  Ke,
  We = {
    name: "gioEmbeddedAdapter",
    method: /*#__PURE__*/_createClass(function method(e) {
      var _this4 = this;
      _classCallCheck(this, method);
      this.growingIO = e, this.main = function () {
        var e;
        var _this4$growingIO$vdsC = _this4.growingIO.vdsConfig,
          t = _this4$growingIO$vdsC.projectId,
          i = _this4$growingIO$vdsC.appId,
          n = _this4.getGQS();
        var r = !1;
        return "none" !== _this4.qsFrom && n.gioprojectid === t && n.gioappid === i && (F(n) ? _this4.growingIO.storage.removeItem(He) : _this4.growingIO.storage.setItem(He, Re.stringify(n)), B(n, "giodatacollect") && (_this4.growingIO.vdsConfig.dataCollect = R(["true", !0], n.giodatacollect)), null === (e = _this4.growingIO.emitter) || void 0 === e || e.on("SDK_INITIALIZED", function () {
          var _this4$growingIO = _this4.growingIO,
            e = _this4$growingIO.userStore,
            t = _this4$growingIO.vdsConfig.sessionExpires,
            i = _this4$growingIO.dataStore.eventContextBuilderInst;
          qe.forEach(function (t) {
            var i;
            e[je[t]] = null !== (i = n[t]) && void 0 !== i ? i : "";
          }), window.setInterval(function () {
            e.sessionId = n.gios;
          }, .8 * t * 60 * 1e3), Ge.forEach(function (e) {
            B(n, e) && (i.minpExtraParams[je[e]] = n[e]);
          });
        }), _this4.growingIO.setUserId = function () {}, _this4.growingIO.clearUserId = function () {}, B(n, "giodatacollect") && (_this4.growingIO.setDataCollect = function () {}, _this4.growingIO.setOption = function () {}), r = !0), _this4.gioURLRewrite(), r;
      }, this.getGQS = function () {
        var e = _this4.growingIO.vdsConfig.hashtag,
          t = _this4.growingIO.storage.getItem(He),
          i = window.location.search,
          n = window.location.hash,
          r = e ? n.substring(n.indexOf("?") + 1) : "",
          s = Re.parse(i),
          o = Re.parse(r),
          a = Re.parse((t || "").replace("gioenc-", ""));
        var d = {};
        if (B(s, "gioprojectid")) d = s, _this4.qsFrom = "search";else if (B(o, "gioprojectid")) d = o, _this4.qsFrom = "hash";else {
          if (!B(a, "gioprojectid")) return _this4.qsFrom = "none", {};
          d = a, _this4.qsFrom = "cookie";
        }
        var c = {},
          l = {},
          h = ["gioappid", "gioprojectid", "giodatacollect"].concat(qe, Ge);
        return K(d).forEach(function (e) {
          var t = e.toLowerCase();
          R(h, t) ? R(["", "undefined", "null", void 0, null], d[e]) || (c[t] = d[e], R(["true", "TRUE", !0], d[e]) && (c[t] = !0), R(["false", "FALSE", !1], d[e]) && (c[t] = !1)) : l[e] = d[e];
        }), _this4.gqs = c, _this4.ngqs = l, c;
      }, this.gioURLRewrite = function () {
        var e = _this4.growingIO.vdsConfig.hashtag;
        var t = window.location.search,
          i = window.location.hash,
          n = !1;
        if ("search" === _this4.qsFrom && (t = Re.stringify(_this4.ngqs, !0), n = !0), e && "hash" === _this4.qsFrom && (i = "".concat(i.split("?")[0]).concat(Re.stringify(_this4.ngqs, !0)), n = !0), n) {
          var _e7 = "".concat(window.location.pathname).concat(t || "").concat(i || "");
          window.history.replaceState(null, document.title, _e7);
        }
      }, this.gqs = {}, this.ngqs = {}, this.qsFrom = "search", this.growingIO.emitter.on(Te, function () {
        _this4.growingIO.useEmbeddedInherit = _this4.main();
      });
    })
  },
  Me = {},
  Ve = {};
Be = Ve, Ke = f && f.__spreadArray || function (e, t, i) {
  if (i || 2 === arguments.length) for (var n, r = 0, s = t.length; s > r; r++) {
    !n && r in t || (n || (n = [].slice.call(t, 0, r)), n[r] = t[r]);
  }
  return e.concat(n || [].slice.call(t));
}, Object.defineProperty(Be, "__esModule", {
  value: !0
}), Be.GROWING_TITLE_OLD = Be.GROWING_TITLE = Be.GROWING_GTITLE = Be.GROWING_CDP_INDEX = Be.GROWING_INDEX_OLD = Be.GROWING_INDEX = Be.GROWING_CONTAINER = Be.GROWING_TRACK = Be.GROWING_IGNORE = Be.VALID_CLASS_SELECTOR = Be.VALID_ID_SELECTOR = Be.EXCLUDE_CLASS_RE = Be.UNSUPPORTED_TAGS = Be.TEXT_NODE = Be.UNSUPPORTED_CLICK_TAGS = Be.SUPPORTED_ICON_TAGS = Be.SUPPORTED_CHANGE_TYPES = Be.SUPPORTED_CLICK_INPUT_TYPES = Be.SUPPORTED_CONTAINER_TAGS = Be.LIST_TAGS = void 0, Be.LIST_TAGS = ["TR", "LI", "DL"], Be.SUPPORTED_CONTAINER_TAGS = Ke(["A", "BUTTON"], Be.LIST_TAGS, !0), Be.SUPPORTED_CLICK_INPUT_TYPES = ["button", "submit", "reset"], Be.SUPPORTED_CHANGE_TYPES = ["radio", "checkbox", "search"], Be.SUPPORTED_ICON_TAGS = ["I", "EM", "svg", "IMG"], Be.UNSUPPORTED_CLICK_TAGS = ["TEXTAREA", "HTML", "BODY"], Be.TEXT_NODE = ["I", "SPAN", "EM", "B", "STRONG"], Be.UNSUPPORTED_TAGS = ["tspan", "text", "g", "rect", "path", "defs", "clippath", "desc", "title", "math", "use"], Be.EXCLUDE_CLASS_RE = /(^| |[^ ]+\-)(clear|clearfix|active|hover|enabled|current|selected|unselected|hidden|display|focus|disabled|undisabled|open|checked|unchecked|undefined|null|ng-|growing-)[^\. ]*/g, Be.VALID_ID_SELECTOR = /^[a-zA-Z-\_][a-zA-Z\-\_0-9]+$/, Be.VALID_CLASS_SELECTOR = /^([a-zA-Z\-\_0-9]+)$/, Be.GROWING_IGNORE = "data-growing-ignore", Be.GROWING_TRACK = "data-growing-track", Be.GROWING_CONTAINER = "data-growing-container", Be.GROWING_INDEX = "data-growing-index", Be.GROWING_INDEX_OLD = "data-growing-idx", Be.GROWING_CDP_INDEX = "data-index", Be.GROWING_GTITLE = "data-growing-title", Be.GROWING_TITLE = "data-title", Be.GROWING_TITLE_OLD = "growing-title";
var Fe = {},
  $e = {};
Object.defineProperty($e, "__esModule", {
  value: !0
}), $e.lastFindIndex = $e.findIndex = $e.arrayEquals = $e.rmBlank = $e.normalizePath = $e.splitNoEmpty = $e.filterText = void 0, $e.filterText = function (e, t) {
  if (void 0 === t && (t = !0), e && (null == (e = e.replace(/[\n \t]+/g, " ").trim()) ? void 0 : e.length)) return e.slice(0, t ? 50 : void 0);
}, $e.splitNoEmpty = function (e, t) {
  return e ? e.split(t).filter(function (e) {
    return !!e;
  }) : [];
}, $e.normalizePath = function (e) {
  var t = e.length;
  return t > 1 && "/" === e.charAt(t - 1) ? e.slice(0, t - 1) : e;
}, $e.rmBlank = function (e) {
  return e ? e.replace(/[\n \t]+/g, "") : "";
}, $e.arrayEquals = function (e, t) {
  if (!e || !t) return !1;
  if (e.length !== t.length) return !1;
  for (var i = 0, n = e.length; n > i; i++) {
    if (e[i] !== t[i]) return !1;
  }
  return !0;
}, $e.findIndex = function (e, t) {
  if (null == e || "function" != typeof t) return -1;
  for (var i = 0; i < e.length; i++) {
    var n = e[i];
    if (t.call(void 0, n)) return i;
  }
  return -1;
}, $e.lastFindIndex = function (e, t) {
  if (null == e || "function" != typeof t) return -1;
  for (var i = e.length - 1; i >= 0; i--) {
    var n = e[i];
    if (t.call(void 0, n)) return i;
  }
  return -1;
}, function (e) {
  var t = f && f.__spreadArray || function (e, t, i) {
      if (i || 2 === arguments.length) for (var n, r = 0, s = t.length; s > r; r++) {
        !n && r in t || (n || (n = [].slice.call(t, 0, r)), n[r] = t[r]);
      }
      return e.concat(n || [].slice.call(t));
    },
    i = f && f.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.removeDiffTagOnHeadAndTail = e.computeXpath = e.getMarkIndex = e.getEffectiveNode = e.isIgnore = e.depthInside = e.changeableInput = e.clickableInput = e.onlyContainsTextChildren = e.onlyContainsIconChildren = e.supportIconTag = e.isContainerTag = e.isListTag = e.isParentOfLeaf = e.isLeaf = e.getChildren = e.getDeepChildren = e.findParent = e.isRootNode = e.hasValidAttribute = void 0;
  var n = $e,
    r = Ve,
    s = i(m);
  e.hasValidAttribute = function (e, t) {
    return e instanceof Element && e.hasAttribute(t) && "false" !== e.getAttribute(t);
  }, e.isRootNode = function (e) {
    return !e || -1 !== ["BODY", "HTML", "#document"].indexOf(e.nodeName);
  }, e.findParent = function (t, i) {
    for (var n = t.parentNode; n && !(0, e.isRootNode)(n);) {
      if (i(n)) return n;
      n = n.parentNode;
    }
  }, e.getDeepChildren = function (i) {
    return (0, s.default)((null == i ? void 0 : i.childNodes) || []).reduce(function (i, n) {
      return n instanceof Element ? t(t(t([], i, !0), [n], !1), (0, e.getDeepChildren)(n), !0) : i;
    }, []);
  }, e.getChildren = function (e) {
    return (0, s.default)((null == e ? void 0 : e.childNodes) || []).filter(function (e) {
      return e instanceof Element;
    });
  }, e.isLeaf = function (t) {
    return !t.hasChildNodes() || "svg" === t.nodeName || 0 === (0, e.getChildren)(t).length;
  }, e.isParentOfLeaf = function (t) {
    return !(!t.hasChildNodes() || "svg" === t.nodeName) && 0 === (0, s.default)(t.childNodes).filter(function (t) {
      return !(0, e.isLeaf)(t);
    }).length;
  }, e.isListTag = function (e) {
    return -1 !== r.LIST_TAGS.indexOf(e.nodeName);
  }, e.isContainerTag = function (t) {
    return (0, e.hasValidAttribute)(t, r.GROWING_CONTAINER) || -1 !== r.SUPPORTED_CONTAINER_TAGS.indexOf(t.nodeName);
  }, e.supportIconTag = function (e) {
    var t = e.nodeName;
    return -1 !== r.SUPPORTED_ICON_TAGS.indexOf(t);
  }, e.onlyContainsIconChildren = function (t) {
    if (t.textContent) return !1;
    var i = (0, e.getChildren)(t);
    if (0 === i.length) return !1;
    for (var n = 0, r = i; n < r.length; n++) {
      var s = r[n];
      if (!(0, e.supportIconTag)(s) && "SPAN" !== s.nodeName) return !1;
    }
    return !0;
  }, e.onlyContainsTextChildren = function (t) {
    return 0 !== (0, e.getChildren)(t).length && !(0, e.getDeepChildren)(t).map(function (e) {
      return e.tagName;
    }).some(function (e) {
      return -1 === r.TEXT_NODE.indexOf(e);
    });
  }, e.clickableInput = function (e) {
    return e instanceof HTMLInputElement && "INPUT" === e.tagName && -1 !== r.SUPPORTED_CLICK_INPUT_TYPES.indexOf(e.type);
  }, e.changeableInput = function (e) {
    return e instanceof HTMLInputElement && "INPUT" === e.tagName && -1 !== r.SUPPORTED_CHANGE_TYPES.indexOf(e.type);
  }, e.depthInside = function (t, i, n) {
    if (void 0 === i && (i = 4), void 0 === n && (n = 1), n > i) return !1;
    for (var r = "svg" === t.tagName ? [] : (0, e.getChildren)(t), s = 0; s < r.length; s++) {
      var o = r[s];
      if (!(0, e.depthInside)(o, i, n + 1)) return !1;
    }
    return i >= n;
  }, e.isIgnore = function (t) {
    if (!(t instanceof Element) || (0, e.hasValidAttribute)(t, r.GROWING_IGNORE)) return !0;
    for (var i = t.parentNode; i && !(0, e.isRootNode)(i);) {
      if ((0, e.hasValidAttribute)(i, r.GROWING_IGNORE)) return !0;
      i = i.parentNode;
    }
    return !1;
  }, e.getEffectiveNode = function (t) {
    for (var i, n; t && (n = void 0, !((i = t) instanceof Element && -1 === r.UNSUPPORTED_TAGS.indexOf(null === (n = i.tagName) || void 0 === n ? void 0 : n.toLowerCase()))) && t.parentNode;) {
      t = t.parentNode;
    }
    var s,
      o = t.parentNode;
    return !(0, e.isRootNode)(o) && ((0, e.onlyContainsIconChildren)(o) || "BUTTON" === (s = o).tagName && (0, e.onlyContainsTextChildren)(s)) ? o : t;
  }, e.getMarkIndex = function (e) {
    if (e instanceof Element) {
      var t = e.getAttribute(r.GROWING_INDEX) || e.getAttribute(r.GROWING_INDEX_OLD) || e.getAttribute(r.GROWING_CDP_INDEX);
      if (t) {
        if (/^\d{1,10}$/.test(t) && +t >= 0 && 2147483647 > +t) return +t;
        window.console.error("[GioNode]：标记的index不符合规范（index必须是大于等于0且小于2147483647的整数字）。", t);
      }
    }
  }, e.computeXpath = function (e) {
    for (var t = e.parentPaths(!0), i = Math.min(t.length, +(t.length >= 10) + 4), n = ["", "", ""], r = 0; r < t.length; r++) {
      var s = t[r].path,
        o = t[r].name;
      n[0] = s + n[0], n[2] = "/".concat(o) + n[2], i > r && (n[1] = s + n[1]);
    }
    return n;
  }, e.removeDiffTagOnHeadAndTail = function (e, t) {
    var i = function i(e) {
        return e.nodeName === t.nodeName;
      },
      r = (0, n.findIndex)(e, i),
      s = (0, n.lastFindIndex)(e, i);
    return -1 === r || -1 === s ? [] : e.slice(r, s + 1);
  };
}(Fe);
var Xe = {},
  ze = {};
Object.defineProperty(ze, "__esModule", {
  value: !0
});
var Je = Ve,
  Ze = $e,
  Qe = Fe;
function Ye(e) {
  var t;
  if (e instanceof Element) {
    var i = e.getAttribute("name");
    if (i) return [i];
    if (e.hasAttribute("class")) {
      var n = null === (t = e.getAttribute("class")) || void 0 === t ? void 0 : t.replace(Je.EXCLUDE_CLASS_RE, "").trim();
      if (null == n ? void 0 : n.length) return n.split(/\s+/).filter(function (e) {
        return Je.VALID_CLASS_SELECTOR.test(e) && !e.match(/[a-z][A-Z][a-z][A-Z]/) && !e.match(/[0-9][0-9][0-9][0-9]/);
      }).sort();
    }
  }
  return [];
}
var et = function () {
  function e(e) {
    var t;
    this.node = e, this.tagName = this.node.nodeName, this.name = this.tagName.toLowerCase(), this.id = (t = this.node).id && Je.VALID_ID_SELECTOR.test(t.id) ? t.id : null, this.classList = Ye(this.node), this.guessListAndIndex();
  }
  return e.prototype.guessListAndIndex = function () {
    var e,
      t = this;
    this._tagList = (0, Qe.isListTag)(this.node);
    var i = (0, Qe.removeDiffTagOnHeadAndTail)((0, Qe.getChildren)(this.node.parentNode), this.node);
    if (this._tagList && -1 !== (s = i.filter(function (e) {
      return e.tagName === t.tagName;
    }).indexOf(this.node)) && (this._index = s + 1), i.length >= 3 && (null === (e = this.classList) || void 0 === e ? void 0 : e.length)) {
      for (var n = 0, r = 0, s = 1; s <= i.length; s++) {
        var o = i[s - 1];
        if (o.tagName !== this.tagName) {
          r = 0;
          break;
        }
        (0, Ze.arrayEquals)(this.classList, Ye(o)) && (r += 1), this.node === o && (n = s);
      }
      3 > r || (this._pseudoList = !0, this._index = this._index || n);
    }
  }, Object.defineProperty(e.prototype, "path", {
    get: function get() {
      var e;
      return this._path || (this._path = "/".concat(this.name), this.id && (this._path += "#".concat(this.id)), (null === (e = this.classList) || void 0 === e ? void 0 : e.length) && (this._path += ".".concat(this.classList.join(".")))), this._path;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "pseudoList", {
    get: function get() {
      return !!this._pseudoList;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "list", {
    get: function get() {
      return !!this._tagList || !!this._pseudoList;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "index", {
    get: function get() {
      var e;
      return null !== (e = (0, Qe.getMarkIndex)(this.node)) && void 0 !== e ? e : this._index;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "container", {
    get: function get() {
      return (0, Qe.isContainerTag)(this.node) || this.list;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "parent", {
    get: function get() {
      return this.node.parentNode ? new e(this.node.parentNode) : null;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.parentPaths = function (e) {
    void 0 === e && (e = !1);
    for (var t = e ? [this] : [], i = this.parent; i && !(0, Qe.isRootNode)(i.node);) {
      t.push(i), i = i.parent;
    }
    return t;
  }, e;
}();
ze.default = et;
var tt = {};
Object.defineProperty(tt, "__esModule", {
  value: !0
}), tt.getElementHref = tt.getImgHref = tt.getAnchorHref = void 0;
var it = $e;
function nt(e) {
  if (e.hasAttribute("href")) {
    var t = e.getAttribute("href");
    if (t && 0 !== t.indexOf("javascript")) return (0, it.normalizePath)(t.slice(0, 320));
  }
}
function rt(e) {
  if (e.src && -1 === e.src.indexOf("data:image")) return e.src;
}
tt.getAnchorHref = nt, tt.getImgHref = rt, tt.getElementHref = function (e) {
  var t = e;
  if (t) switch (e.nodeName.toLowerCase()) {
    case "a":
      return nt(t);
    case "img":
      return rt(t);
  }
};
var st = {},
  ot = f && f.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
Object.defineProperty(st, "__esModule", {
  value: !0
}), st.getElementContent = st.getFormContent = void 0;
var at = Fe,
  dt = tt,
  ct = Ve,
  lt = ot(ze),
  ht = $e,
  ut = ot(m),
  gt = function gt(e) {
    return e.htmlFor || e.getAttribute("for");
  },
  pt = function pt(e) {
    var t = e.getAttribute(ct.GROWING_GTITLE) || e.getAttribute(ct.GROWING_TITLE) || e.getAttribute(ct.GROWING_TITLE_OLD) || e.getAttribute("title");
    return null == t ? void 0 : t.trim();
  };
function ft(e) {
  var t = e.node;
  return e.list ? mt(t) : (0, ht.filterText)(t.textContent) || void 0;
}
function mt(e) {
  for (var t = void 0, i = !1, n = 0, r = (0, ut.default)(e.childNodes); n < r.length; n++) {
    var s = r[n];
    if (s.nodeType === Node.TEXT_NODE) {
      var o = (0, ht.filterText)(s.textContent);
      if (o) return o;
    }
    if (s.nodeType === Node.ELEMENT_NODE && -1 === ["INPUT", "SELECT"].indexOf(s.nodeName)) {
      if (new lt.default(s).pseudoList) return;
      i = (0, at.onlyContainsIconChildren)(s) || (0, at.supportIconTag)(s);
      var a = It(s);
      if (i) t = a, i = !1;else if (a || (a = mt(s)), a) return a;
    }
  }
  return t;
}
function vt(e) {
  for (var t = e.getElementsByTagName("input"), i = 0, n = (0, ut.default)(t); i < n.length; i++) {
    var r = n[i];
    if (("search" === r.type || "text" === r.type && ("q" === r.id || -1 !== r.id.indexOf("search") || "q" === r.name || -1 !== r.name.indexOf("search"))) && !(0, at.isIgnore)(r)) {
      var s = It(r);
      if (s) return s;
    }
  }
}
function It(e) {
  return function (e) {
    var t = e;
    if (t) {
      var i = pt(t);
      if (i) return i;
      var n,
        r,
        s,
        o = new lt.default(e);
      switch (e.nodeName.toLowerCase()) {
        case "a":
          return function (e) {
            if (((0, at.isLeaf)(e) || (0, at.onlyContainsIconChildren)(e)) && e.textContent) {
              var t = (0, ht.filterText)(e.textContent);
              if (t) return t;
            }
            var i = (0, dt.getAnchorHref)(e);
            if (i) {
              var n = i.indexOf("?");
              return n > -1 ? i.slice(0, n) : i;
            }
          }(t);
        case "svg":
          return function (e) {
            for (var t = 0, i = (0, ut.default)(e.childNodes); t < i.length; t++) {
              var n = i[t];
              if (n.nodeType === Node.ELEMENT_NODE && "use" === n.tagName.toLowerCase() && n.hasAttribute("xlink:href")) return n.getAttribute("xlink:href");
            }
          }(t);
        case "button":
          return (null === (s = (r = t).name) || void 0 === s ? void 0 : s.length) ? r.name : (0, ht.filterText)(r.textContent) || mt(r);
        case "img":
          return function (e) {
            if (e.alt) return e.alt;
            var t = (0, dt.getImgHref)(e);
            if (t) {
              var i = t.split("?")[0].split("/");
              if (i.length > 0) return i[i.length - 1];
            }
          }(t);
        case "label":
          return ft(o);
        case "input":
          return function (e) {
            if ((0, at.clickableInput)(e)) return e.value;
            if ("password" !== e.type && (0, at.hasValidAttribute)(e, ct.GROWING_TRACK)) return e.value;
            if ((0, at.changeableInput)(e)) {
              var t = (0, at.findParent)(e, function (e) {
                return "LABEL" === e.nodeName;
              });
              if (!t && e.id) for (var i = document.body.getElementsByTagName("label"), n = 0; n < i.length; n++) {
                var r = i[n];
                if (gt(r) === e.id) {
                  t = r;
                  break;
                }
              }
              if (t) {
                var s = ft(new lt.default(t));
                if (s && s.length > 0) return s + " (" + e.checked + ")";
              }
              return e.value;
            }
          }(t);
        case "select":
          return n = t, (0, ut.default)(n.options).filter(function (e) {
            return e.selected;
          }).map(function (e) {
            return e.label;
          }).join(", ") || n.value;
        case "form":
          return vt(t);
      }
      return (0, at.isLeaf)(t) ? function (e) {
        var t = (0, ht.filterText)(e.textContent);
        if (t) return t;
      }(t) : (0, at.isParentOfLeaf)(t) && !(0, at.onlyContainsIconChildren)(t) ? function (e) {
        for (var t = "", i = 0, n = (0, ut.default)(e.childNodes); i < n.length; i++) {
          var r = n[i];
          t += (r.nodeType === Node.TEXT_NODE && r.textContent ? r.textContent.trim() : "") + " ";
        }
        return (0, ht.filterText)(t, !1);
      }(t) : o.container || (0, at.onlyContainsIconChildren)(e) ? mt(t) : void 0;
    }
  }(e) || void 0;
}
st.getFormContent = vt, st.getElementContent = It;
var _wt,
  Ot = f && f.__extends || (_wt = function wt(e, t) {
    return _wt = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var i in t) {
        ({}).hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }, _wt(e, t);
  }, function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + t + " is not a constructor or null");
    function i() {
      this.constructor = e;
    }
    _wt(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i());
  }),
  bt = f && f.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
Object.defineProperty(Xe, "__esModule", {
  value: !0
});
var yt = bt(ze),
  Et = tt,
  _t = st,
  St = Fe,
  Tt = function (e) {
    function t(t) {
      var i = e.call(this, t) || this;
      i.node = t;
      var n = (0, St.computeXpath)(i),
        r = n[0],
        s = n[1],
        o = n[2];
      return i.fullXpath = r, i.xpath = s, i.skeleton = o, i;
    }
    return Ot(t, e), Object.defineProperty(t.prototype, "href", {
      get: function get() {
        return (0, Et.getElementHref)(this.node);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "content", {
      get: function get() {
        return (0, _t.getElementContent)(this.node);
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(yt.default);
Xe.default = Tt;
var Nt = f && f.__assign || function () {
    return Nt = Object.assign || function (e) {
      for (var t, i = 1, n = arguments.length; n > i; i++) {
        for (var r in t = arguments[i]) {
          ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }
      return e;
    }, Nt.apply(this, arguments);
  },
  Ct = f && f.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
Object.defineProperty(Me, "__esModule", {
  value: !0
});
var xt = Ve,
  At = Fe,
  Pt = Ct(Xe),
  Dt = function () {
    function e(e, t, i) {
      void 0 === t && (t = null), void 0 === i && (i = !0), this.origin = e, this.action = t, this.direct = i, this.target = "self" === t ? e : (0, At.getEffectiveNode)(e), this.ignore = (0, At.isIgnore)(this.target), this.vnode = new Pt.default(this.target), this.tagName = this.vnode.tagName;
    }
    return Object.defineProperty(e.prototype, "content", {
      get: function get() {
        return this.vnode.content;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "href", {
      get: function get() {
        return this.vnode.href;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "index", {
      get: function get() {
        return this.vnode.index;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.inferParentIndex = function () {
      var t = this;
      return this.parentIndex || (0, At.findParent)(this.target, function (i) {
        var n = new e(i, t.action, !1);
        n.traceable() && n.index && (t.parentIndex = n.index);
      }), this.parentIndex;
    }, Object.defineProperty(e.prototype, "xpath", {
      get: function get() {
        return this.vnode.xpath;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "fullXpath", {
      get: function get() {
        return this.vnode.fullXpath;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "skeleton", {
      get: function get() {
        return this.vnode.skeleton;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.info = function (e) {
      return void 0 === e && (e = !0), e && this.inferParentIndex(), {
        skeleton: this.skeleton,
        fullXpath: this.fullXpath,
        xpath: this.xpath,
        content: this.content,
        href: this.href,
        index: this.parentIndex || this.index
      };
    }, e.prototype.traceable = function () {
      if (this.ignore) return !1;
      if (this.direct) {
        if ("click" === this.action || "hover" === this.action) {
          if (-1 !== xt.UNSUPPORTED_CLICK_TAGS.indexOf(this.target.tagName)) return !1;
          if ("INPUT" === this.target.tagName && !(0, At.clickableInput)(this.target)) return !1;
          if (!(0, At.isContainerTag)(this.target) && !(0, At.depthInside)(this.target, 5)) return !1;
        }
        return !0;
      }
      return this.vnode.container;
    }, e.prototype.trackNodes = function () {
      if (!this.traceable()) return [];
      var e = [this];
      if ("submit" !== this.action) for (var t = this.parentElement; t;) {
        if (t.ignore) return [];
        t.traceable() && e.unshift(t), t = t.parentElement;
      }
      var i = void 0;
      return e.map(function (e) {
        var t = e.info(!1),
          n = t.index;
        return !i && n && (i = n), Nt(Nt({}, t), {
          index: i || n
        });
      });
    }, Object.defineProperty(e.prototype, "parentElement", {
      get: function get() {
        var t = this.target.parentNode;
        if (t && t.nodeName && !(0, At.isRootNode)(t)) return new e(t, this.action, !1);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(),
  Rt = Me.default = Dt;
var Lt = /*#__PURE__*/function () {
  function Lt(e) {
    _classCallCheck(this, Lt);
    this.handler = e;
    var t = navigator.userAgent,
      i = /chrome/i.exec(t),
      n = /android/i.exec(t);
    this.hasTouch = "ontouchstart" in window && !(i && !n);
  }
  _createClass(Lt, [{
    key: "main",
    value: function main() {
      var e = this.hasTouch ? ["touchstart"] : ["mousedown"],
        t = this.hasTouch ? ["touchend", "touchcancel"] : ["mouseup", "mouseleave"],
        i = this.hasTouch ? ["touchmove"] : ["mousemove"];
      for (var _i5 = 0, _e8 = e; _i5 < _e8.length; _i5++) {
        var _t12 = _e8[_i5];
        Q(window, _t12, this.touchStartHandler.bind(this));
      }
      for (var _i7 = 0, _i6 = i; _i7 < _i6.length; _i7++) {
        var _e9 = _i6[_i7];
        Q(window, _e9, this.touchMoveHandler.bind(this));
      }
      for (var _i8 = 0, _t13 = t; _i8 < _t13.length; _i8++) {
        var _e10 = _t13[_i8];
        Q(window, _e10, this.touchStopHandler.bind(this));
      }
    }
  }, {
    key: "touchStartHandler",
    value: function touchStartHandler(e) {
      if (e.which > 1) return;
      var t = +Date.now();
      this.safeguard !== t && (this.touchTimeout && clearTimeout(this.touchTimeout), this.safeguard = t, this.touchEvent = {
        time: t,
        target: e.target,
        x: this._page("x", e),
        y: this._page("y", e),
        isTrusted: !0,
        type: "click"
      });
    }
  }, {
    key: "touchMoveHandler",
    value: function touchMoveHandler(e) {
      var t = Math.abs(this._page("x", e) - (this.touchEvent && this.touchEvent.x) || 0),
        i = Math.abs(this._page("y", e) - (this.touchEvent && this.touchEvent.y) || 0);
      (t > 10 || i > 10) && (this.touchEvent = null);
    }
  }, {
    key: "touchStopHandler",
    value: function touchStopHandler(e) {
      var _this5 = this;
      var t = +Date.now() - (this.touchEvent && this.touchEvent.time) || 0;
      this.touchEvent && 200 > t ? this.touchTimeout = setTimeout(function () {
        _this5.handler(_this5.touchEvent), _this5.touchEvent = null;
      }, 200) : this.touchEvent && t >= 200 && 700 > t && (this.handler(this.touchEvent), this.touchEvent = null);
    }
  }, {
    key: "_page",
    value: function _page(e, t) {
      return (this.hasTouch ? t.touches[0] : t)["page" + e.toUpperCase()];
    }
  }]);
  return Lt;
}();
var kt = {
  name: "gioEventAutoTracking",
  method: /*#__PURE__*/_createClass(function method(e) {
    var _this6 = this;
    _classCallCheck(this, method);
    this.growingIO = e, this.main = function () {
      Q(document, "submit", _this6._handleAction), Q(document, "change", _this6._handleAction);
      var e = _this6.growingIO.vdsConfig;
      e.touch ? new Lt(_this6._handleAction).main() : Q(document, "click", _this6._handleAction);
    }, this._handleAction = function (e, t) {
      var _this6$growingIO = _this6.growingIO,
        i = _this6$growingIO.vdsConfig,
        n = _this6$growingIO.emitter;
      if (!i.autotrack) return !1;
      var r = e.target;
      if (!r) return !1;
      var s = new Rt(r, e.type, !0).trackNodes();
      if ("click" !== e.type && (s = F(C(s)) ? [] : [C(s)]), F(s)) return !1;
      null == n || n.emit("onComposeBefore", {
        event: t,
        params: null != e ? e : {}
      }), s.forEach(function (t) {
        var n = t.fullXpath,
          r = t.index,
          s = t.content,
          o = t.href;
        if (!G(t.fullXpath || "", "/div#__vconsole") && !G(t.fullXpath || "", "/div#__giokit") && (i.debug && console.log("Action：", e.type, Date.now()), n)) {
          var _this6$growingIO$data = _this6.growingIO.dataStore,
            _t14 = _this6$growingIO$data.eventContextBuilder,
            _i9 = _this6$growingIO$data.eventConverter,
            _a = _this6$growingIO$data.currentPage;
          _i9(Object.assign(Object.assign({
            eventType: c[e.type],
            element: [{
              xpath: n,
              index: r,
              textValue: s,
              hyperlink: o
            }]
          }, _t14()), {
            pageShowTimestamp: _a.time
          }));
        }
      });
    };
  })
};
var Ut;
var jt = ["VIEW_CLICK", "VIEW_CHANGE", "FORM_SUBMIT", "PAGE", "CUSTOM", "LOGIN_USER_ATTRIBUTES"],
  Gt = ["LOGIN_USER_ATTRIBUTES"];
var qt = {
  name: "gioHybridAdapter",
  method: /*#__PURE__*/_createClass(function method(e) {
    var _this7 = this;
    _classCallCheck(this, method);
    this.growingIO = e, this.penetrateHybrid = !0, this.onOptionsInit = function () {
      var _this7$growingIO = _this7.growingIO,
        e = _this7$growingIO.vdsConfig,
        t = _this7$growingIO.emitter;
      b(e.penetrateHybrid) && (_this7.penetrateHybrid = e.penetrateHybrid), _this7._initHybridBridge() && (_this7.onSendBefore = _this7.sendBeforeListener, _this7.hybridConfig.projectId === _this7.growingIO.vdsConfig.projectId && (_this7.growingIO.useHybridInherit = !0)), _this7.growingIO.useHybridInherit && (null == t || t.on(xe, function (_ref) {
        var e = _ref.newUserId,
          t = _ref.oldUserId,
          i = _ref.userKey;
        _this7.penetrateHybrid && (!e && t ? i ? _this7._clearNativeUserIdAndUserKey() : _this7._clearNativeUserId() : i ? _this7._setNativeUserIdAndUserKey(k(e), k(i)) : _this7._setNativeUserId(k(e)));
      }), null == t || t.on(Ae, function (_ref2) {
        var e = _ref2.newUserKey,
          t = _ref2.oldUserKey,
          i = _ref2.userId;
        _this7.penetrateHybrid && (!e && t ? _this7._clearNativeUserIdAndUserKey() : _this7._setNativeUserIdAndUserKey(k(i), k(e)));
      }));
    }, this._initHybridBridge = function () {
      var e, t, i;
      var n = !1;
      return _this7.hasHybridBridge = !!window.GrowingWebViewJavascriptBridge, _this7.hasHybridBridge ? ((null === (e = null === window || void 0 === window ? void 0 : window.GrowingWebViewJavascriptBridge) || void 0 === e ? void 0 : e.configuration) || (window.GrowingWebViewJavascriptBridge.configuration = JSON.parse(window.GrowingWebViewJavascriptBridge.getConfiguration())), (null === (t = null === window || void 0 === window ? void 0 : window.GrowingWebViewJavascriptBridge) || void 0 === t ? void 0 : t.configuration) && (_this7.hybridConfig = null === (i = null === window || void 0 === window ? void 0 : window.GrowingWebViewJavascriptBridge) || void 0 === i ? void 0 : i.configuration), n = !0) : Ut.consoleText("gioHybridAdapter：当前不存在 GrowingWebViewJavascriptBridge，Web模式。", "info"), n;
    }, this.sendBeforeListener = function (_ref3) {
      var e = _ref3.requestData;
      if (_this7.hasHybridBridge) {
        var _t15 = _this7.processAttributes(Object.assign({}, e));
        R(jt, _t15.eventType) && (R(Gt, _t15.eventType) ? _this7.penetrateHybrid && _this7._dispatchEvent(_t15) : (_this7.penetrateHybrid || V(_t15, ["userId", "userKey", "cs1"]), _this7._dispatchEvent(_t15)));
      }
    }, this.processAttributes = function (e) {
      return W(e, function (t, i) {
        y(t) || S(t) ? W(e[i], function (t, n) {
          y(t) || S(t) ? e[i][n] = JSON.stringify(t) : e[i][n] = k(t);
        }) : e[i] = k(t);
      }), e;
    }, this._setNativeUserId = function (e) {
      J(function () {
        return window.GrowingWebViewJavascriptBridge.setNativeUserId(e);
      });
    }, this._clearNativeUserId = function () {
      J(function () {
        return window.GrowingWebViewJavascriptBridge.clearNativeUserId();
      });
    }, this._setNativeUserIdAndUserKey = function (e, t) {
      J(function () {
        return window.GrowingWebViewJavascriptBridge.setNativeUserIdAndUserKey(e, t);
      });
    }, this._clearNativeUserIdAndUserKey = function () {
      J(function () {
        return window.GrowingWebViewJavascriptBridge.clearNativeUserIdAndUserKey();
      });
    }, this._dispatchEvent = function (e) {
      J(function () {
        var t;
        return null === (t = window.GrowingWebViewJavascriptBridge) || void 0 === t ? void 0 : t.dispatchEvent(JSON.stringify(e));
      });
    };
    var _this$growingIO = this.growingIO,
      t = _this$growingIO.emitter,
      i = _this$growingIO.utils;
    Ut = i, t.on(Te, this.onOptionsInit);
  })
};
var Ht = ["i", "span", "em", "b", "strong", "svg"];
var Bt;
!function (e) {
  e[e.OUTER = 0] = "OUTER", e[e.INNER_COVERED = 1] = "INNER_COVERED", e[e.INNER_SHOW = 2] = "INNER_SHOW";
}(Bt || (Bt = {}));
var Kt = ["HR", "BR", "SCRIPT", "NOSCRIPT", "STYLE", "HEAD", "BASE", "LINK", "META", "TITLE", "BODY", "HTML", "TEMPLATE", "CODE"].concat(_toConsumableArray(Ve.UNSUPPORTED_CLICK_TAGS)),
  Wt = ["SELECT", "A", "BUTTON", "INPUT", "IMG", "FORM"],
  Mt = function Mt(e, t, i) {
    return document.elementFromPoint(t, i) === e;
  };
var Vt = /*#__PURE__*/function () {
  function Vt(e, t, i) {
    _classCallCheck(this, Vt);
    this.node = e, this.parentNodeDesc = t, this.devicesInfo = i, this.proxy = new Rt(e), this.tagName = this.node.tagName, this.name = this.tagName.toLowerCase(), this.isIgnore = !!this.node.dataset.growingIgnore, this.isUnSupported = -1 !== Kt.indexOf(this.tagName), this.rect = this.computeWindowRect();
  }
  _createClass(Vt, [{
    key: "info",
    value: function info() {
      var e = this.desc();
      e.zLevel += this.devicesInfo.webviewZLevel;
      var t = this.getDeviceRect(this.rect);
      return V(e, "isContainer"), Object.assign(Object.assign(Object.assign({}, e), t), {
        parentXPath: this.parentNodeDesc.isContainer ? this.parentNodeDesc.xpath : void 0,
        href: this.proxy.href,
        content: this.proxy.content,
        nodeType: this.nodeType()
      });
    }
  }, {
    key: "nodeType",
    value: function nodeType() {
      return "input" !== this.name || Fe.changeableInput(this.node) ? this.node.tagName : "INPUT_BTN";
    }
  }, {
    key: "desc",
    value: function desc() {
      return {
        index: this.parentNodeDesc.index || this.proxy.index,
        zLevel: this.zLevel(),
        xpath: this.proxy.xpath,
        isContainer: this.isDefinedContainer()
      };
    }
  }, {
    key: "cssVisible",
    value: function cssVisible() {
      var e = this.computedStyle();
      return Number(e.opacity) > 0 && "visible" === e.visibility && "none" !== e.display;
    }
  }, {
    key: "viewportStatus",
    value: function viewportStatus() {
      var _this$rect = this.rect,
        e = _this$rect.top,
        t = _this$rect.left,
        i = _this$rect.width,
        n = _this$rect.height,
        _this$devicesInfo = this.devicesInfo,
        r = _this$devicesInfo.winWidth,
        s = _this$devicesInfo.winHeight;
      if (0 >= i || 0 >= n) return Bt.OUTER;
      var o = this.node;
      return s > e && r > t && i > 0 && n > 0 ? Mt(o, t + i / 2, e + n / 2) || Mt(o, t + 1, e + 1) || Mt(o, t + i - 1, e + 1) || Mt(o, t + 1, e + n - 1) || Mt(o, t + i - 1, e + n - 1) ? Bt.INNER_SHOW : Bt.INNER_COVERED : Bt.OUTER;
    }
  }, {
    key: "isCircleable",
    value: function isCircleable() {
      return this.proxy.target === this.proxy.origin && (!!this.isDefinedContainer() || !("input" === this.name && this.node instanceof HTMLInputElement && "password" === this.node.type) && (-1 !== Wt.indexOf(this.name) || (Fe.isLeaf(this.node) ? !this.isBigBlank() : this.hasBackgroundImage() && Fe.depthInside(this.node, 4))));
    }
  }, {
    key: "isSimpleContainer",
    value: function isSimpleContainer() {
      return "select" === this.name || this.isDefaultContainer() && (function (e, t) {
        if (0 === e.children.length) return !1;
        var _iterator2 = _createForOfIteratorHelper(L(e.children)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _i10 = _step2.value;
            if (-1 === t.indexOf(_i10.tagName.toLowerCase())) return !1;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return !0;
      }(this.node, Ht) || !this.node.childElementCount);
    }
  }, {
    key: "isDefinedContainer",
    value: function isDefinedContainer() {
      var e;
      return v(this.isContainer) ? this.isDefaultContainer() || this.isMarkContainer() || Fe.isParentOfLeaf(this.node) && (!!(null === (e = this.node.innerText) || void 0 === e ? void 0 : e.trim().length) || function (e) {
        var t = e.attributes;
        if (t.length > 0) for (var _e11 = 0; _e11 < t.length; _e11++) {
          var _i11 = t[_e11].value;
          if (_i11 && "false" !== _i11) return !0;
        }
        return !1;
      }(this.node)) || "select" === this.name : !!this.isContainer;
    }
  }, {
    key: "isDefaultContainer",
    value: function isDefaultContainer() {
      return -1 !== Ve.SUPPORTED_CONTAINER_TAGS.indexOf(this.tagName) || Fe.clickableInput(this.node);
    }
  }, {
    key: "isMarkContainer",
    value: function isMarkContainer() {
      return this.node.hasAttribute("data-growing-container") || this.node.hasAttribute("growing-container");
    }
  }, {
    key: "isBigBlank",
    value: function isBigBlank() {
      var e, t;
      var i = null !== (t = null === (e = this.node.innerText) || void 0 === e ? void 0 : e.trim().length) && void 0 !== t ? t : 0,
        _this$rect2 = this.rect,
        n = _this$rect2.width,
        r = _this$rect2.height,
        _this$devicesInfo2 = this.devicesInfo,
        s = _this$devicesInfo2.winWidth,
        o = _this$devicesInfo2.winHeight;
      return !i && (n > s >> 1 || r > o >> 1);
    }
  }, {
    key: "hasBackgroundImage",
    value: function hasBackgroundImage() {
      var e = this.computedStyle().backgroundImage;
      return !!e && "none" !== e && e.length > 0;
    }
  }, {
    key: "zLevel",
    value: function zLevel() {
      var e = this.computedStyle(),
        t = e.zIndex;
      if ("auto" !== t) return Number(t || "0") + this.parentNodeDesc.zLevel;
      switch (e.position) {
        case "relative":
          return this.parentNodeDesc.zLevel + 2;
        case "sticky":
          return this.parentNodeDesc.zLevel + 3;
        case "absolute":
          return this.parentNodeDesc.zLevel + 4;
        case "fixed":
          return this.parentNodeDesc.zLevel + 5;
        default:
          return this.parentNodeDesc.zLevel + 1;
      }
    }
  }, {
    key: "computeWindowRect",
    value: function computeWindowRect() {
      if (this.rect) return this.rect;
      var e = this.node.getBoundingClientRect(),
        t = e.top,
        i = e.bottom,
        n = e.left;
      var r = e.right - n,
        s = i - t;
      return 0 > t ? s = t + s : t + s > this.devicesInfo.winHeight && (s = this.devicesInfo.winHeight - t), 0 > n ? r = n + r : n + r > this.devicesInfo.winWidth && (r = this.devicesInfo.winWidth - n), this.rect = {
        top: t,
        left: n,
        width: r,
        height: s
      }, this.rect;
    }
  }, {
    key: "computedStyle",
    value: function computedStyle() {
      return window.getComputedStyle(this.node);
    }
  }, {
    key: "getDeviceRect",
    value: function getDeviceRect(e) {
      var _this$devicesInfo3 = this.devicesInfo,
        t = _this$devicesInfo3.scale,
        i = _this$devicesInfo3.webviewTop,
        n = _this$devicesInfo3.webviewLeft;
      return {
        top: e.top * t + i,
        left: e.left * t + n,
        width: e.width * t,
        height: e.height * t
      };
    }
  }]);
  return Vt;
}();
var Ft = ["DOMContentLoaded", "onreadystatechange"],
  $t = ["scroll", "resize", "load", "beforeunload", "popstate", "hashchange", "pagehide", "unload"];
var Xt = /*#__PURE__*/function () {
  function Xt(e) {
    _classCallCheck(this, Xt);
    this.growingIO = e, this.addDomChangeListener();
  }
  _createClass(Xt, [{
    key: "getDomTree",
    value: function getDomTree(e, t, i, n, r, s) {
      var o = function (e, t, i, n, r) {
          var s = document.documentElement.clientWidth;
          return {
            winWidth: s,
            winHeight: document.documentElement.clientHeight,
            scale: i / s,
            webviewTop: t,
            webviewLeft: e,
            webviewWidth: i,
            webviewHeight: n,
            webviewZLevel: r
          };
        }(e, t, i, n, r),
        a = this.getElementsByParent(s || document.body, {
          isContainer: !1,
          zLevel: 0
        }, o),
        _this$growingIO$dataS = this.growingIO.dataStore.currentPage,
        d = _this$growingIO$dataS.domain,
        c = _this$growingIO$dataS.path,
        l = _this$growingIO$dataS.query,
        h = _this$growingIO$dataS.title;
      return {
        page: {
          domain: d,
          path: c,
          query: l,
          title: h
        },
        elements: a
      };
    }
  }, {
    key: "getElementsByParent",
    value: function getElementsByParent(e, t, i) {
      var _this8 = this;
      var n = [];
      return [].slice.call(e.childNodes, 0).filter(function (e) {
        return 1 === e.nodeType;
      }).forEach(function (e) {
        var r = new Vt(e, t, i);
        if (r.cssVisible() && !r.isIgnore) {
          switch (r.viewportStatus()) {
            case Bt.INNER_SHOW:
              r.isCircleable() && n.push(r.info());
              break;
            case Bt.INNER_COVERED:
              r.isDefaultContainer() && n.push(r.info());
          }
          r.isSimpleContainer() || [].push.apply(n, _this8.getElementsByParent(e, r.desc(), i));
        }
      }), n;
    }
  }, {
    key: "addDomChangeListener",
    value: function addDomChangeListener() {
      var e;
      var t = function t() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return function () {
          var i;
          "beforeunload" === t && e && e.disconnect(), null === (i = window.GrowingWebViewJavascriptBridge) || void 0 === i || i.onDomChanged();
        };
      };
      e = new MutationObserver(t("mutation")), e.observe(document.body, {
        attributes: !0,
        characterData: !0,
        childList: !0,
        subtree: !0
      }), Ft.forEach(function (e) {
        Q(document, e, t(e));
      }), $t.forEach(function (e) {
        Q(window, e, t(e));
      });
    }
  }]);
  return Xt;
}();
var zt = /*#__PURE__*/function () {
  function zt(e) {
    var _this9 = this;
    _classCallCheck(this, zt);
    var t;
    this.growingIO = e, null === (t = this.growingIO.emitter) || void 0 === t || t.on(Ne, function () {
      if (window.GrowingWebViewJavascriptBridge) {
        var _e12 = _this9;
        window.GrowingWebViewJavascriptBridge.getDomTree = function () {
          if (arguments.length >= 4) return zt.bindGetDomTree(_e12.growingIO), zt.domHelper.getDomTree.apply(zt.domHelper, arguments);
        };
      }
    });
  }
  _createClass(zt, null, [{
    key: "bindGetDomTree",
    value: function bindGetDomTree(e) {
      this.domHelper || (this.domHelper = new Xt(e), window.GrowingWebViewJavascriptBridge.getDomTree = this.domHelper.getDomTree.bind(this.domHelper));
    }
  }]);
  return zt;
}();
var Jt = {
    name: "gioHybridCircle",
    method: zt
  },
  Zt = {
    name: "gioImpressionTracking",
    method: /*#__PURE__*/_createClass(function method(e) {
      var _this10 = this;
      _classCallCheck(this, method);
      var t;
      this.growingIO = e, this.documentReady = !1, this.main = function (e) {
        "listener" === e ? (_this10.documentReady = !0, _this10.growingIO.gioSDKInitialized && _this10.initMutationObserver()) : "emitter" === e && _this10.documentReady && _this10.initMutationObserver();
      }, this.initIntersectionObserver = function () {
        _this10.intersectionObserver = new IntersectionObserver(function (e) {
          F(e) || e.map(function (e) {
            var t = e.target.dataset;
            if (e.intersectionRatio > 0) {
              var _this10$getImpression = _this10.getImpressionProperties(t),
                _e13 = _this10$getImpression.eventId,
                _i12 = _this10$getImpression.properties,
                _n8 = _this10$getImpression.items,
                _r3 = t.id;
              if (_r3) {
                if ("once" === t.gioImpType && B(_this10.sentImps, _r3)) return;
                _this10.sentImps[_r3] = {
                  eventId: _e13,
                  properties: _i12,
                  items: _n8
                };
              }
              _e13 && _this10.growingIO.track(_e13, _i12, _n8);
            }
          });
        });
      }, this.initMutationObserver = function () {
        if (_this10.mutationObserver) return !1;
        var e = document.querySelectorAll("[data-gio-imp-track]");
        L(e).map(function (e) {
          var t;
          null === (t = _this10.intersectionObserver) || void 0 === t || t.observe(e);
        }), _this10.mutationObserver = new MutationObserver(function (e) {
          return e.map(function (e) {
            var t;
            if ("attributes" === e.type) {
              var _i13 = e.target.dataset;
              if (_i13.gioImpTrack) return null === (t = _this10.intersectionObserver) || void 0 === t ? void 0 : t.observe(e.target);
            }
          });
        }), _this10.mutationObserver.observe(document.body, {
          attributes: !0,
          childList: !0,
          subtree: !0,
          attributeOldValue: !0,
          attributeFilter: ["data-gio-imp-track", "data-gio-imp-attrs", "data-gio-imp-items", /^data-gio-track-[a-z]+$/i]
        });
      }, this.getImpressionProperties = function (e) {
        var t = {
          eventId: void 0,
          properties: {}
        };
        if (!(null == e ? void 0 : e.gioImpTrack)) return t;
        if (t.eventId = e.gioImpTrack, B(e, "gioImpAttrs")) t.properties = J(function () {
          return y(e.gioImpAttrs) ? e.gioImpAttrs : JSON.parse(e.gioImpAttrs);
        }), t.items = J(function () {
          return y(e.gioImpItems) ? e.gioImpItems : JSON.parse(e.gioImpItems);
        });else {
          var _i14 = /^gioTrack(.+)/;
          for (var _n9 in e) {
            var _r4 = void 0;
            var _s = _n9.match(_i14);
            _s && (_r4 = j(_s[1]), "track" !== _r4 && (t.properties[_r4] = e[_n9]));
          }
        }
        return t.properties = Z(t.properties), t.items = Z(t.items), /^\w+$/.test(t.eventId) && !Number.isInteger(Number(N(t.eventId.split("")))) || (t.eventId = null, t = {}), t;
      }, this.sentImps = {}, window.ActiveXObject || "ActiveXObject" in window || navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("Trident") > -1 && navigator.userAgent.indexOf("rv:11.0") > -1 ? z("IE浏览器不支持半自动埋点，gioImpressionTracking已自动关闭！", "warn") : (this.initIntersectionObserver(), Q(document, "readystatechange", function () {
        R(["interactive", "complete"], document.readyState) && _this10.main("listener");
      }, {
        once: !0
      }), null === (t = this.growingIO.emitter) || void 0 === t || t.on(Ne, function () {
        return _this10.main("emitter");
      }), Q(window, "unload", function () {
        var e, t;
        null === (e = _this10.intersectionObserver) || void 0 === e || e.disconnect(), null === (t = _this10.mutationObserver) || void 0 === t || t.disconnect();
      }));
    })
  },
  Qt = {
    name: "gioWebCircle",
    method: /*#__PURE__*/_createClass(function method(e) {
      var _this11 = this;
      _classCallCheck(this, method);
      var t;
      this.growingIO = e, this.injectCircle = function (e, t) {
        var i = document.createElement("link"),
          n = document.createElement("script");
        i.rel = "stylesheet", i.href = e, n.src = t, document.head.appendChild(i), document.head.appendChild(n);
      }, null === (t = this.growingIO.emitter) || void 0 === t || t.on(Ne, function () {
        window.addEventListener("message", function (e) {
          var t = e.data,
            i = e.source,
            n = window.vds;
          if (t && i) {
            var _e14 = i.vds,
              _r5 = t.cssURL,
              _s2 = t.jsURL;
            _e14 && "SDK_INJECT_CIRCLE_SCRIPT" === t.type && n.projectId === _e14.projectId && n.dataSourceId === _e14.dataSourceId && _this11.injectCircle(_r5, _s2);
          }
        });
      });
    })
  };
var Yt = ["gioPerformance"];
var ei = /*#__PURE__*/_createClass(function ei(e) {
  var _this12 = this;
  _classCallCheck(this, ei);
  var t, i, n, r;
  this.growingIO = e, this.innerPluginInit = function () {
    var e;
    Yt.forEach(function (e) {
      var t;
      return V(null === (t = _this12.pluginsContext) || void 0 === t ? void 0 : t.plugins, e);
    }), K(null === (e = _this12.pluginsContext) || void 0 === e ? void 0 : e.plugins).forEach(function (e) {
      var t;
      var _ref4 = null === (t = _this12.pluginsContext) || void 0 === t ? void 0 : t.plugins[e],
        i = _ref4.name,
        n = _ref4.method;
      P(_this12.pluginItems, function (e) {
        return e.name === i;
      }) || _this12.pluginItems.push({
        name: j(i || e),
        method: n || function (e) {}
      });
    }), F(_this12.pluginItems) || _this12.installAll();
  }, this.install = function (e, t, i) {
    var n, r;
    var s = t || P(_this12.pluginItems, function (t) {
      return t.name === e;
    });
    if ((null === (n = _this12.growingIO) || void 0 === n ? void 0 : n.plugins)[e]) return z("\u91CD\u590D\u52A0\u8F7D\u63D2\u4EF6 ".concat(e, " \u6216\u63D2\u4EF6\u91CD\u540D\uFF0C\u5DF2\u8DF3\u8FC7\u52A0\u8F7D!"), "warn"), !1;
    if (!s) return z("\u63D2\u4EF6\u52A0\u8F7D\u5931\u8D25!\u4E0D\u5B58\u5728\u540D\u4E3A ".concat(e, " \u7684\u63D2\u4EF6!"), "error"), !1;
    try {
      return (null === (r = _this12.growingIO) || void 0 === r ? void 0 : r.plugins)[e] = new s.method(_this12.growingIO, i), "cdp" === _this12.growingIO.gioEnvironment && t && z("加载插件 " + e, "info"), !0;
    } catch (e) {
      return z("插件加载异常 " + e, "error"), !1;
    }
  }, this.installAll = function (e) {
    (e || _this12.pluginItems).forEach(function (t) {
      _this12.install(t.name, e ? t : void 0, e ? null == t ? void 0 : t.options : void 0) && !P(_this12.pluginItems, function (e) {
        return e.name === t.name;
      }) && _this12.pluginItems.push({
        name: j(t.name),
        method: t.method ? t.method : function () {}
      });
    });
  }, this.uninstall = function (e) {
    var t;
    V(_this12.pluginItems, e);
    var i = V(null === (t = _this12.growingIO) || void 0 === t ? void 0 : t.plugins, e);
    return i || z("\u5378\u8F7D\u63D2\u4EF6 ".concat(e, " \u5931\u8D25!"), "error"), i;
  }, this.uninstallAll = function () {
    _this12.pluginItems.forEach(function (e) {
      return _this12.uninstall(e.name);
    });
  }, this.lifeError = function (e, t) {
    return z("\u63D2\u4EF6\u6267\u884C\u9519\u8BEF ".concat(e.name, " ").concat(t), "error");
  }, this.onComposeBefore = function (e) {
    _this12.pluginItems.forEach(function (t) {
      var i;
      var n = null === (i = _this12.growingIO.plugins[t.name]) || void 0 === i ? void 0 : i.onComposeBefore;
      if (n && _(n)) try {
        n(e);
      } catch (e) {
        _this12.lifeError(t, e);
      }
    });
  }, this.onComposeAfter = function (e) {
    _this12.pluginItems.forEach(function (t) {
      var i;
      var n = null === (i = _this12.growingIO.plugins[t.name]) || void 0 === i ? void 0 : i.onComposeAfter;
      if (n && _(n)) try {
        n(e);
      } catch (e) {
        _this12.lifeError(t, e);
      }
    });
  }, this.onSendBefore = function (e) {
    _this12.pluginItems.forEach(function (t) {
      var i;
      var n = null === (i = _this12.growingIO.plugins[t.name]) || void 0 === i ? void 0 : i.onSendBefore;
      if (n && _(n)) try {
        n(e);
      } catch (e) {
        _this12.lifeError(t, e);
      }
    });
  }, this.onSendAfter = function (e) {
    _this12.pluginItems.forEach(function (t) {
      var i;
      var n = null === (i = _this12.growingIO.plugins[t.name]) || void 0 === i ? void 0 : i.onSendAfter;
      if (n && _(n)) try {
        n(e);
      } catch (e) {
        _this12.lifeError(t, e);
      }
    });
  }, this.pluginsContext = {
    plugins: {}
  }, this.pluginItems = [], null === (t = this.growingIO.emitter) || void 0 === t || t.on("onComposeBefore", this.onComposeBefore), null === (i = this.growingIO.emitter) || void 0 === i || i.on("onComposeAfter", this.onComposeAfter), null === (n = this.growingIO.emitter) || void 0 === n || n.on("onSendBefore", this.onSendBefore), null === (r = this.growingIO.emitter) || void 0 === r || r.on("onSendAfter", this.onSendAfter);
});
var ti = /*#__PURE__*/function (_ei) {
  _inherits(ti, _ei);
  var _super = _createSuper(ti);
  function ti(e) {
    var _this13;
    _classCallCheck(this, ti);
    _this13 = _super.call(this, e), _this13.growingIO = e, _this13.growingIO.gioSDKFull = !0, _this13.pluginsContext = {
      plugins: {
        gioCompress: Pe,
        gioCustomTracking: De,
        gioEmbeddedAdapter: We,
        gioEventAutoTracking: kt,
        gioHybridAdapter: qt,
        gioHybridCircle: Jt,
        gioImpressionTracking: Zt,
        gioWebCircle: Qt
      }
    };
    return _this13;
  }
  return _createClass(ti);
}(ei);
var ii = /*#__PURE__*/_createClass(function ii() {
  var _this14 = this;
  _classCallCheck(this, ii);
  var e;
  this.trackingId = "g0", this.init = function (e) {
    var t, i, n, r, s;
    z("Gio Web SDK 初始化中...", "info");
    var _this14$dataStore = _this14.dataStore,
      o = _this14$dataStore.initOptions,
      a = _this14$dataStore.currentPage,
      d = _this14$dataStore.sendVisit,
      c = _this14$dataStore.sendPage;
    o(e), _this14.storage = Se(_this14.vdsConfig), _this14.initCallback(), null === (t = _this14.emitter) || void 0 === t || t.emit(Te, _this14), null === (n = null === (i = _this14.plugins) || void 0 === i ? void 0 : i.gioEventAutoTracking) || void 0 === n || n.main(), a.hookHistory(), a.parsePage(), null === (r = _this14.emitter) || void 0 === r || r.emit(Ne, _this14), z("Gio Web SDK 初始化完成！", "success"), _this14.useEmbeddedInherit || d(), c(), _this14.gioSDKInitialized = !0, _this14.vdsConfig.gioSDKInitialized = !0, window[_this14.vds] = _this14.vdsConfig, null === (s = _this14.emitter) || void 0 === s || s.emit("SDK_INITIALIZED_COMPLATE", _this14);
  }, this.setOption = function (e, t) {
    if (R(s, e)) {
      var _i15 = _this14.dataStore.setOption(e, t);
      return _i15 && o[e] && z("\u5DF2".concat(t ? "开启" : "关闭").concat(o[e]), "info"), _i15;
    }
    return z("\u4E0D\u5B58\u5728\u53EF\u4FEE\u6539\u7684\u914D\u7F6E\u9879\uFF1A".concat(e, "\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u8BD5!"), "warn"), !1;
  }, this.getOption = function (e) {
    return _this14.dataStore.getOption(e);
  }, this.setGeneralProps = function (e) {
    y(e) && !F(e) ? (_this14.dataStore.generalProps = Object.assign(Object.assign({}, _this14.dataStore.generalProps), e), K(_this14.dataStore.generalProps).forEach(function (e) {
      R([void 0, null], _this14.dataStore.generalProps[e]) && (_this14.dataStore.generalProps[e] = "");
    })) : _this14.callError("setGeneralProps");
  }, this.clearGeneralProps = function (e) {
    S(e) && !F(e) ? e.forEach(function (e) {
      V(_this14.dataStore.generalProps, e);
    }) : _this14.dataStore.generalProps = {};
  }, this.reissuePage = function () {
    _this14.dataStore.sendPage();
  }, this.notRecommended = function () {
    return z("不推荐的方法使用，建议使用 gio('setOption', [optionName], [value])!", "info");
  }, this.callError = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "参数不合法";
    return z("".concat(t ? "调用" : "设置", " ").concat(e, " \u5931\u8D25\uFF0C").concat(i, "!"), "warn");
  }, this.gioEnvironment = "cdp", this.sdkVersion = "3.8.5", this.vds = window.gioCompatibilityVds ? "gdp_vds" : "vds", this.utils = Object.assign(Object.assign(Object.assign({}, X), ee), {
    qs: Re
  }), this.emitter = {
    all: e = e || new Map(),
    on: function on(t, i) {
      var n = e.get(t);
      n ? n.push(i) : e.set(t, [i]);
    },
    off: function off(t, i) {
      var n = e.get(t);
      n && (i ? n.splice(n.indexOf(i) >>> 0, 1) : e.set(t, []));
    },
    emit: function emit(t, i) {
      var n = e.get(t);
      n && n.slice().map(function (e) {
        e(i);
      }), (n = e.get("*")) && n.slice().map(function (e) {
        e(t, i);
      });
    }
  }, this.useEmbeddedInherit = !1, this.useHybridInherit = !1, this.gioSDKInitialized = !1, this.plugins = new ti(this), this.plugins.innerPluginInit();
});
var ni = /*#__PURE__*/function () {
  function ni(e) {
    var _this15 = this;
    _classCallCheck(this, ni);
    var t;
    this.growingIO = e;
    var i = this.growingIO.vdsConfig.projectId,
      _this$growingIO$stora = this.growingIO.storage,
      n = _this$growingIO$stora.getItem,
      r = _this$growingIO$stora.setItem,
      s = _this$growingIO$stora.getKeys,
      o = _this$growingIO$stora.removeItem;
    this.getItem = n, this.setItem = r, this.getKeys = s, this.removeItem = o, this.sIdStorageName = i + "_gdp_session_id", this.uidStorageName = "gdp_user_id_gioenc", this.userIdStorageName = i + "_gdp_cs1_gioenc", this.userKeyStorageName = i + "_gdp_user_key_gioenc", this.gioIdStorageName = i + "_gdp_gio_id_gioenc", null === (t = this.growingIO.emitter) || void 0 === t || t.on(Ce, function () {
      _this15.growingIO.gioSDKInitialized && (_this15.growingIO.dataStore.sendVisit(!0), _this15.growingIO.dataStore.sendPage(!0));
    });
  }
  _createClass(ni, [{
    key: "sessionId",
    get: function get() {
      return this.getItem(this.sIdStorageName) || (this.sessionId = oe(), this.sessionId);
    },
    set: function set(e) {
      var _this16 = this;
      var t;
      e || (e = oe());
      var i = this.getItem(this.sIdStorageName) || this.prevSessionId,
        _this$growingIO$vdsCo = this.growingIO.vdsConfig.sessionExpires,
        n = _this$growingIO$vdsCo === void 0 ? 30 : _this$growingIO$vdsCo;
      this.setItem(this.sIdStorageName, e, +Date.now() + 60 * n * 1e3), i !== e && (this.getKeys().filter(function (e) {
        return /.+_gdp_session_id_.{36}/.test(e);
      }).forEach(function (e) {
        _this16.removeItem(e);
      }), this.setItem(this.growingIO.dataStore.visitStorageName, ""), null === (t = this.growingIO.emitter) || void 0 === t || t.emit(Ce, {
        newSessionId: e,
        oldSessionId: i
      })), this.prevSessionId = e;
    }
  }, {
    key: "uid",
    get: function get() {
      return this.getItem(this.uidStorageName) || (this.uid = oe(), this.uid);
    },
    set: function set(e) {
      var t;
      var i = this.getItem(this.uidStorageName) || this.prevUId;
      this.setItem(this.uidStorageName, e), i !== e && (null === (t = this.growingIO.emitter) || void 0 === t || t.emit("UID_UPDATE", {
        newUId: e,
        oldUId: i
      })), this.prevUId = e;
    }
  }, {
    key: "userId",
    get: function get() {
      return this.getItem(this.userIdStorageName) || "";
    },
    set: function set(e) {
      var t, i;
      var n = this.getItem(this.userIdStorageName) || this.prevUserId;
      this.setItem(this.userIdStorageName, e), null === (t = this.growingIO.emitter) || void 0 === t || t.emit(xe, {
        newUserId: e,
        oldUserId: n,
        userKey: this.userKey
      }), n !== e && (null === (i = this.growingIO.emitter) || void 0 === i || i.emit("USERID_UPDATE", {
        newUserId: e,
        oldUserId: n,
        userKey: this.userKey
      })), e && (this.gioId = e), this.prevUserId = e;
    }
  }, {
    key: "userKey",
    get: function get() {
      return this.getItem(this.userKeyStorageName) || "";
    },
    set: function set(e) {
      var t, i;
      var n = this.getItem(this.userKeyStorageName) || this.prevUserKey;
      this.setItem(this.userKeyStorageName, e), null === (t = this.growingIO.emitter) || void 0 === t || t.emit(Ae, {
        newUserKey: e,
        oldUserKey: n,
        userId: this.userId
      }), n !== e && (null === (i = this.growingIO.emitter) || void 0 === i || i.emit("USERKEY_UPDATE", {
        newUserKey: e,
        oldUserKey: n,
        userId: this.userId
      })), this.prevUserKey = e;
    }
  }, {
    key: "gioId",
    get: function get() {
      return this.getItem(this.gioIdStorageName) || "";
    },
    set: function set(e) {
      var t;
      var i = this.getItem(this.gioIdStorageName) || this.prevGioId;
      this.setItem(this.gioIdStorageName, e), i !== e && (null === (t = this.growingIO.emitter) || void 0 === t || t.emit("GIOID_UPDATE", {
        newGioId: e,
        oldGioId: i
      })), this.prevGioId = e;
    }
  }]);
  return ni;
}();
var ri = /*#__PURE__*/_createClass(function ri(e) {
  var _this17 = this;
  _classCallCheck(this, ri);
  this.growingIO = e, this.main = function () {
    var e;
    var _this17$growingIO = _this17.growingIO,
      t = _this17$growingIO.sdkVersion,
      i = _this17$growingIO.useEmbeddedInherit,
      n = _this17$growingIO.vdsConfig,
      r = _this17$growingIO.userStore,
      s = _this17$growingIO.dataStore,
      o = _this17$growingIO.trackingId,
      _s$currentPage = s.currentPage,
      a = _s$currentPage.path,
      d = _s$currentPage.query;
    var c = {
      appVersion: n.version,
      dataSourceId: n.dataSourceId,
      deviceId: r.uid,
      domain: i ? n.appId : window.location.host,
      gioId: r.gioId,
      language: navigator.language,
      path: a,
      platform: n.platform,
      query: d,
      referralPage: (null === (e = s.lastPageEvent) || void 0 === e ? void 0 : e.referralPage) || "",
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      sdkVersion: t,
      sessionId: r.sessionId,
      timestamp: +Date.now(),
      title: document.title.slice(0, 255),
      userId: r.userId
    };
    if (n.enableIdMapping && (c.userKey = r.userKey), F(n.ignoreFields) || n.ignoreFields.forEach(function (e) {
      V(c, e);
    }), i && !F(_this17.minpExtraParams)) {
      var _e15 = Object.assign({}, c);
      W(Object.assign(Object.assign({}, c), _this17.minpExtraParams), function (t, i) {
        var r;
        R(n.embeddedIgnore, i) ? (c[i] = _e15[i], "domain" === i && (c[i] = window.location.host)) : c[i] = null !== (r = _this17.minpExtraParams[i]) && void 0 !== r ? r : c[i];
      });
    }
    return c.trackingId = o, c;
  }, this.minpExtraParams = {};
});
var si = /*#__PURE__*/_createClass(function si(e) {
  var _this18 = this;
  _classCallCheck(this, si);
  this.growingIO = e, this.parsePage = function () {
    var e = _this18.growingIO.vdsConfig.hashtag,
      t = location.pathname,
      i = location.search,
      n = location.hash,
      r = n.indexOf("?");
    _this18.domain = window.location.host, _this18.title = document.title.slice(0, 255), _this18.time = +Date.now(), _this18.path = t, _this18.query = i, e && (r > -1 ? (_this18.path += n.slice(0, r), _this18.query = _this18.query + "&" + n.slice(r + 1)) : _this18.path += n), _this18.query && R(["?", "&"], _this18.query.charAt(0)) && (_this18.query = _this18.query.slice(1));
  }, this._getNoHashHref = function () {
    var _window$location = window.location,
      e = _window$location.protocol,
      t = _window$location.host,
      i = _window$location.pathname,
      n = _window$location.search;
    return "".concat(e, "://").concat(t).concat(i).concat(n);
  }, this.pageListener = function () {
    var e = _this18.growingIO.vdsConfig.hashtag;
    var t = window.location.href,
      i = _this18.lastHref;
    e || (t = _this18._getNoHashHref(), i = _this18.lastNoHashHref), i !== t && (_this18.parsePage(), _this18.buildPageEvent());
  }, this.hookHistory = function () {
    var e = window.history.pushState,
      t = window.history.replaceState,
      i = _this18;
    e && J(function () {
      return window.history.pushState = function () {
        e.apply(window.history, arguments), setTimeout(i.pageListener);
      };
    }), t && J(function () {
      return window.history.replaceState = function () {
        t.apply(window.history, arguments), setTimeout(i.pageListener);
      };
    }), Q(window, "popstate", _this18.pageListener);
    var n = _this18.growingIO.vdsConfig.hashtag;
    n && Q(window, "hashchange", _this18.pageListener);
  }, this.buildPageEvent = function (e) {
    var _this18$growingIO$dat = _this18.growingIO.dataStore,
      t = _this18$growingIO$dat.lastPageEvent,
      i = _this18$growingIO$dat.eventContextBuilder,
      n = _this18$growingIO$dat.eventConverter;
    var r = Object.assign(Object.assign({
      eventType: "PAGE"
    }, i()), {
      protocolType: location.protocol.substring(0, location.protocol.length - 1),
      referralPage: (null == t ? void 0 : t.path) === _this18.path && (null == t ? void 0 : t.query) === _this18.query ? null == t ? void 0 : t.referralPage : (null == t ? void 0 : t.path) ? _this18.lastHref : document.referrer
    });
    F(e) || (r = Object.assign(Object.assign({}, r), e)), r.timestamp = _this18.time, n(r), _this18.lastHref = window.location.href, _this18.lastNoHashHref = _this18._getNoHashHref(), _this18.lastLocation = Object.assign({}, window.location);
  }, this.title = document.title.slice(0, 255), this.lastLocation = Object.assign({}, window.location);
});
var oi = {
  referralPage: document.referrer
};
var ai = /*#__PURE__*/function () {
  function ai(r) {
    var _this19 = this;
    _classCallCheck(this, ai);
    var a, c;
    this.growingIO = r, this.ALLOW_SETTING = Object.assign(Object.assign({}, t), "saas" === this.growingIO.gioEnvironment ? n : i), this.allowOptKeys = Object.keys(this.ALLOW_SETTING), this.trackTimers = {}, this.setSequenceIds = function (e, t) {
      var i = _this19.growingIO.storage.getItem(_this19.seqStorageIdName) || {};
      "gsid" === e ? i.globalKey = t : i = Object.assign(Object.assign({}, i), t), _this19.growingIO.storage.setItem(_this19.seqStorageIdName, i);
    }, this.initOptions = function (t) {
      var i, n, r, s, a, c, l;
      var h = t.projectId,
        u = t.dataSourceId,
        g = t.appId;
      _this19.initialDataSourceId = u;
      var p = {};
      _this19.allowOptKeys.forEach(function (i) {
        var n = _this19.ALLOW_SETTING[i].type;
        var r = S(n) ? !R(n, $(t[i])) : $(t[i]) !== n;
        "platform" !== i || R(e, t[i]) || (r = !0), r ? p[i] = _this19.ALLOW_SETTING[i].default : "ignoreFields" === i ? p.ignoreFields = t.ignoreFields.filter(function (e) {
          return R(d, e);
        }) : (p[i] = t[i], R(["dataCollect", "autotrack"], i) && (p[i] || z("已关闭" + o[i], "info")));
      }), p.sessionExpires = Math.round(p.sessionExpires), (O(p.sessionExpires) || 1 > p.sessionExpires || p.sessionExpires > 360) && (p.sessionExpires = 30), p.storageType = p.storageType.toLowerCase(), _this19.growingIO.vdsConfig = Object.assign(Object.assign(Object.assign({}, null !== (i = window.vds) && void 0 !== i ? i : {}), p), {
        projectId: h,
        dataSourceId: u,
        appId: g,
        performance: {
          monitor: null === (r = null === (n = p.performance) || void 0 === n ? void 0 : n.monitor) || void 0 === r || r,
          exception: null === (a = null === (s = p.performance) || void 0 === s ? void 0 : s.exception) || void 0 === a || a,
          network: null !== (l = null === (c = p.performance) || void 0 === c ? void 0 : c.network) && void 0 !== l && l
        }
      }), window.vds = _this19.growingIO.vdsConfig, _this19.seqStorageIdName = h + "_gdp_sequence_ids", _this19.visitStorageName = h + "_gdp_session_id_sent";
    }, this.setOption = function (e, t) {
      var i;
      var _this19$growingIO = _this19.growingIO,
        n = _this19$growingIO.vdsConfig,
        r = _this19$growingIO.callError,
        o = _this19$growingIO.uploader,
        a = _this19$growingIO.emitter,
        d = I(e) && R(s, e),
        c = d && typeof t === ((null === (i = _this19.ALLOW_SETTING[e]) || void 0 === i ? void 0 : i.type) || "string"),
        l = Object.assign({}, n);
      return d && c ? (n[e] = t, "dataCollect" === e && l.dataCollect !== t && (t ? (_this19.sendVisit(!0), _this19.sendPage()) : _this19.growingIO.clearTrackTimer()), R(["host", "scheme"], e) && (null == o || o.generateHost()), null == a || a.emit("OPTION_CHANGE", {
        optionName: e,
        optionValue: t
      }), window.vds[e] = t, !0) : (r("setOption > " + e), !1);
    }, this.getOption = function (e) {
      var _this19$growingIO2 = _this19.growingIO,
        t = _this19$growingIO2.vdsConfig,
        i = _this19$growingIO2.callError;
      return e && B(t, k(e)) ? t[k(e)] : v(e) ? Object.assign({}, t) : void i("getOption > " + e);
    }, this.sendVisit = function (e) {
      var _this19$growingIO3 = _this19.growingIO,
        t = _this19$growingIO3.userStore.sessionId,
        i = _this19$growingIO3.vdsConfig.dataCollect,
        n = _this19$growingIO3.storage;
      if (i) {
        var _i16 = n.getItem(_this19.visitStorageName);
        !e && t === _i16 || (_this19.buildVisitEvent(), n.setItem(_this19.visitStorageName, t));
      }
    }, this.buildVisitEvent = function (e) {
      var _this19$growingIO$dat = _this19.growingIO.dataStore,
        t = _this19$growingIO$dat.eventContextBuilder,
        i = _this19$growingIO$dat.eventConverter,
        n = _this19.lastVisitEvent;
      var r = Object.assign(Object.assign({
        eventType: "VISIT"
      }, t()), {
        referralPage: n.referralPage
      });
      F(e) || (r.session = (null == e ? void 0 : e.session) || r.session, r.trackingId = null == e ? void 0 : e.trackingId, r = Object.assign(Object.assign({}, r), e)), (null == n ? void 0 : n.path) && (r.title = n.title, r.path = n.path, r.query = n.query, r.timestamp = n.timestamp), i(r);
    }, this.sendPage = function (e) {
      e && _this19.currentPage.parsePage(), _this19.currentPage.buildPageEvent();
    }, this.buildErrorEvent = function (e) {
      var _this19$growingIO$dat2 = _this19.growingIO.dataStore,
        t = _this19$growingIO$dat2.eventContextBuilder,
        i = _this19$growingIO$dat2.eventConverter;
      i(Object.assign({
        eventType: "CUSTOM",
        pageShowTimestamp: _this19.currentPage.time,
        eventName: "onError",
        attributes: e
      }, t()));
    }, this.currentPage = new si(this.growingIO), this.eventContextBuilderInst = new ri(this.growingIO), this.eventContextBuilder = this.eventContextBuilderInst.main, this.generalProps = {}, this.lastVisitEvent = oi, null === (a = this.growingIO.emitter) || void 0 === a || a.on("onComposeAfter", function (_ref5) {
      var e = _ref5.composedEvent;
      "VISIT" !== e.eventType && "vst" !== e.t || e.trackingId !== _this19.growingIO.trackingId || (_this19.lastVisitEvent = e);
    }), this.lastPageEvent = {}, null === (c = this.growingIO.emitter) || void 0 === c || c.on("onComposeAfter", function (_ref6) {
      var e = _ref6.composedEvent;
      "PAGE" !== e.eventType && "page" !== e.t || e.trackingId !== _this19.growingIO.trackingId || (_this19.lastPageEvent = e);
    });
  }
  _createClass(ai, [{
    key: "esid",
    get: function get() {
      var _this20 = this;
      var e = this.growingIO.storage.getItem(this.seqStorageIdName) || {};
      var t = Object.assign({}, e);
      return V(t, "globalKey"), t = y(t) && !v(t) ? t : {}, this._esid = {}, K(t).forEach(function (e) {
        _this20._esid[e] = O(Number(t[e])) || t[e] >= 1e9 || 1 > t[e] ? 1 : t[e];
      }), this._esid;
    },
    set: function set(e) {
      var t = {};
      K(e).forEach(function (i) {
        t[i] = O(e[i]) || e[i] >= 1e9 || 1 > e[i] ? 1 : e[i];
      }), M(this._esid, t) || (this._esid = t, this.setSequenceIds("esid", this._esid));
    }
  }, {
    key: "gsid",
    get: function get() {
      var e = this.growingIO.storage.getItem(this.seqStorageIdName) || {},
        t = Number(e.globalKey);
      return this._gsid = O(t) || t >= 1e9 || 1 > t ? 1 : t, this._gsid;
    },
    set: function set(e) {
      O(Number(e)) || e >= 1e9 || 1 > e ? this._gsid = 1 : this._gsid = e, this.setSequenceIds("gsid", this._gsid);
    }
  }]);
  return ai;
}();
var di = /*#__PURE__*/function (_ai) {
  _inherits(di, _ai);
  var _super2 = _createSuper(di);
  function di(e) {
    var _this21;
    _classCallCheck(this, di);
    _this21 = _super2.call(this, e), _this21.growingIO = e, _this21.eventConverter = function (e) {
      var t;
      var _this21$growingIO = _this21.growingIO,
        i = _this21$growingIO.vdsConfig,
        n = _this21$growingIO.dataStore,
        r = _this21$growingIO.uploader;
      if (i.dataCollect) {
        e.trackingId === _this21.growingIO.trackingId && (e.globalSequenceId = n.gsid, e.eventSequenceId = n.esid[e.eventType] || 1);
        var _i17 = {};
        W(e, function (e, t) {
          var n;
          if ("element" === t) {
            var _t16 = null !== (n = N(e)) && void 0 !== n ? n : {};
            W(_t16, function (e, t) {
              F(e) && 0 !== e || (_i17[t] = e);
            });
          } else (F(e) || v(e)) && 0 !== e || (_i17[t] = e);
        }), e.trackingId === _this21.growingIO.trackingId && (_this21.growingIO.dataStore.gsid += 1, _this21.growingIO.dataStore.esid = Object.assign(Object.assign({}, _this21.growingIO.dataStore.esid), _defineProperty({}, _i17.eventType, (_this21.growingIO.dataStore.esid[_i17.eventType] || 1) + 1))), null === (t = _this21.growingIO.emitter) || void 0 === t || t.emit("onComposeAfter", {
          composedEvent: Object.assign({}, _i17)
        }), e.trackingId === _this21.growingIO.trackingId && r.commitRequest(_i17);
      }
    };
    return _this21;
  }
  return _createClass(di);
}(ai);
var ci = /*#__PURE__*/_createClass(function ci(e) {
  var _this22 = this;
  _classCallCheck(this, ci);
  this.growingIO = e, this.commitRequest = function (e) {
    var t = Object.assign({}, e);
    _this22.requestQueue.push(Object.assign(Object.assign({}, t), {
      requestType: ae() ? "Beacon" : "XHR"
    })), _this22.initiateRequest();
  }, this.initiateRequest = function () {
    var e, t;
    if (_toConsumableArray(_this22.requestQueue).length > 0 && _this22.requestingNum < _this22.requestLimit) {
      var _this22$growingIO = _this22.growingIO,
        _i18 = _this22$growingIO.vdsConfig,
        _n10 = _this22$growingIO.emitter,
        _r6 = _this22$growingIO.plugins,
        _s3 = _this22$growingIO.useHybridInherit;
      if (_this22.requestQueue = _toConsumableArray(_this22.requestQueue).filter(function (e) {
        return (_this22.retryIds[e.globalSequenceId || e.esid] || 0) <= _this22.retryLimit;
      }), F(_this22.requestQueue)) return;
      var _o = _this22.requestQueue.shift(),
        _a2 = _o.requestType;
      null == _n10 || _n10.emit("onSendBefore", {
        requestData: Object.assign({}, _o)
      });
      var _d = Object.assign({}, _o);
      if (V(_d, ["requestType", "trackingId"]), _i18.debug && console.log("[GrowingIO Debug]:", JSON.stringify(_d, null, 2).replace(/\"/g, function () {
        var e = window.navigator.userAgent;
        return /(\d+\.\d)?(?:\.\d)?\s+safari\/?(\d+\.\d+)?/i.test(e) && !/chrome\/(\d+\.\d+)/i.test(e);
      }() ? "" : '"')), _this22.requestingNum += 1, _s3) return _this22.requestSuccessFn(_o), !1;
      var _c = Object.assign({}, _d);
      switch (_i18.compress && (null === (e = null == _r6 ? void 0 : _r6.gioCompress) || void 0 === e ? void 0 : e.compressToUint8Array) ? (_this22.compressType = "1", _c = null === (t = null == _r6 ? void 0 : _r6.gioCompress) || void 0 === t ? void 0 : t.compressToUint8Array(JSON.stringify([_c]))) : (_this22.compressType = "0", _c = JSON.stringify([_c])), _a2) {
        case "Beacon":
        default:
          _this22.sendByBeacon(_o, _c);
          break;
        case "XHR":
          _this22.sendByXHR(_o, _c);
          break;
        case "Image":
          _this22.sendByImage(_o, _c);
      }
    }
  }, this.generateURL = function () {
    return "".concat(_this22.requestURL, "?stm=").concat(+Date.now(), "&compress=").concat(_this22.compressType);
  }, this.sendByBeacon = function (e, t) {
    navigator.sendBeacon(_this22.generateURL(), t) ? _this22.requestSuccessFn(e) : _this22.requestFailFn(e, "Beacon");
  }, this.sendByXHR = function (e, t) {
    var i;
    var n = R(["unload", "beforeunload", "pagehide"], null === (i = null === window || void 0 === window ? void 0 : window.event) || void 0 === i ? void 0 : i.type),
      r = new XMLHttpRequest();
    if (r) return r.open("POST", _this22.generateURL(), n), r.onreadystatechange = function () {
      4 === r.readyState && 204 === r.status ? _this22.requestSuccessFn(e) : _this22.requestFailFn(e, "XHR");
    }, r.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"), void r.send(t);
    if (null === window || void 0 === window ? void 0 : window.XDomainRequest) {
      var _i19 = new window.XDomainRequest();
      _i19.open("POST", _this22.generateURL().replace("https://", "http://"), n), _i19.onload = function () {
        204 === _i19.status ? _this22.requestSuccessFn(e) : _this22.requestFailFn(e, "XHR");
      }, _i19.onerror = _i19.ontimeout = function () {
        _this22.requestFailFn(e, "XHR");
      }, _i19.send(t);
    }
  }, this.sendByImage = function (e, t) {
    var i = "".concat(_this22.generateURL(), "&data=").concat(t);
    var n = document.createElement("img");
    n.width = 1, n.height = 1, n.onload = function () {
      _this22.requestSuccessFn(e), _this22.clearImage(n);
    }, n.onerror = n.onabort = function () {
      _this22.requestFailFn(e, "Image"), _this22.clearImage(n);
    }, n.src = i;
  }, this.clearImage = function (e) {
    e.src = "", e.onload = function () {}, e.onerror = e.onerabort = function () {}, e = null;
  }, this.requestSuccessFn = function (e) {
    var t;
    _this22.requestingNum -= 1;
    var i = e.globalSequenceId || e.esid || -1;
    _this22.retryIds[i] && (_this22.retryIds[i] = 0), e.trackingId === _this22.growingIO.trackingId && (_this22.growingIO.userStore.sessionId = e.sessionId), null === (t = _this22.growingIO.emitter) || void 0 === t || t.emit("onSendAfter", {
      requestData: Object.assign({}, e)
    }), _this22.initiateRequest();
  }, this.requestFailFn = function (e, t) {
    _this22.requestingNum -= 1;
    var i = e.globalSequenceId || e.esid || -1;
    _this22.retryIds[i] || (_this22.retryIds[i] = 0), _this22.retryIds[i] += 1;
    var n = _this22.requestQueue.some(function (t) {
      return t.globalSequenceId === e.globalSequenceId && t.esid === e.esid;
    });
    var r = t;
    if (_this22.retryIds[i] < _this22.retryLimit + 1 || (r = "Beacon" === t ? "XHR" : "XHR" === t ? "Image" : void 0, _this22.retryIds[i] = 0), !n && r) {
      var _t17 = window.setTimeout(function () {
        F(_this22.requestQueue) ? (_this22.requestQueue.push(Object.assign(Object.assign({}, e), {
          requestType: r
        })), _this22.initiateRequest()) : _this22.requestQueue.push(Object.assign(Object.assign({}, e), {
          requestType: r
        })), window.clearTimeout(_t17), _t17 = null;
      }, 800);
    }
  }, this.requestQueue = [], this.requestLimit = 10, this.requestTimeout = 5e3, this.retryLimit = 1, this.retryIds = {}, this.requestingNum = 0, this.requestURL = "";
});
var li = /*#__PURE__*/function (_ci) {
  _inherits(li, _ci);
  var _super3 = _createSuper(li);
  function li(e) {
    var _this23;
    _classCallCheck(this, li);
    _this23 = _super3.call(this, e), _this23.growingIO = e, _this23.generateHost = function () {
      var _this23$growingIO$vds = _this23.growingIO.vdsConfig,
        e = _this23$growingIO$vds.scheme,
        _this23$growingIO$vds2 = _this23$growingIO$vds.host,
        t = _this23$growingIO$vds2 === void 0 ? "" : _this23$growingIO$vds2,
        i = _this23$growingIO$vds.projectId;
      e ? q(k(e), "://") || (e += "://") : e = (location.protocol.indexOf("http") > -1 ? location.protocol.replace(":", "") : "https") + "//", G(t, "http") && (t = t.substring(t.indexOf("://") + (q(k(e), "://") ? 3 : 0))), _this23.requestURL = "".concat(e).concat(t, "/v3/projects/").concat(i, "/collect");
    }, _this23.requestURL = "", _this23.generateHost();
    return _this23;
  }
  return _createClass(li);
}(ci);
var hi = /*#__PURE__*/function (_ii) {
  _inherits(hi, _ii);
  var _super4 = _createSuper(hi);
  function hi() {
    var _this24;
    _classCallCheck(this, hi);
    _this24 = _super4.call(this), _this24.registerPlugins = function (e) {
      S(e) ? (e.forEach(function (t, i) {
        var n, r;
        F(t) || v(t) ? z("插件不合法，跳过加载!", "warn") : (null === (n = t.js) || void 0 === n ? void 0 : n.default) && (e[i] = Object.assign(Object.assign({}, null === (r = t.js) || void 0 === r ? void 0 : r.default), {
          options: t.options
        }));
      }), e = A(e), _this24.plugins.installAll(e)) : z("插件注册失败，请检查!", "error");
    }, _this24.initCallback = function () {
      _this24.uploader = new li(_assertThisInitialized(_this24)), _this24.userStore = new ni(_assertThisInitialized(_this24));
    }, _this24.getPlugins = function () {
      return _this24.plugins.pluginItems;
    }, _this24.setTrackerScheme = function (e) {
      R(["http", "https"], e) ? (_this24.dataStore.setOption("scheme", e), _this24.notRecommended()) : _this24.callError("scheme", !1);
    }, _this24.setTrackerHost = function (e) {
      ie.test(e) || ne.test(e) ? (_this24.dataStore.setOption("host", e), _this24.notRecommended()) : _this24.callError("host", !1);
    }, _this24.setDataCollect = function (e) {
      _this24.setOption("dataCollect", !!e), _this24.notRecommended();
    }, _this24.setAutotrack = function (e) {
      _this24.setOption("autotrack", !!e), _this24.notRecommended();
    }, _this24.enableDebug = function (e) {
      _this24.setOption("debug", !!e), _this24.notRecommended();
    }, _this24.enableHT = function (e) {
      _this24.setOption("hashtag", !!e), _this24.notRecommended();
    }, _this24.getVisitorId = function () {
      return _this24.userStore.uid;
    }, _this24.getDeviceId = function () {
      return _this24.userStore.uid;
    }, _this24.setUserAttributes = function (e, t) {
      var i, n;
      !F(e) && y(e) ? null === (n = null === (i = _this24.plugins) || void 0 === i ? void 0 : i.gioCustomTracking) || void 0 === n || n.buildUserAttributesEvent(e, t) : _this24.callError("setUserAttributes");
    }, _this24.setUserId = function (e, t) {
      if (te(k(e).trim())) {
        var _i20 = _this24.userStore.gioId;
        _this24.vdsConfig.enableIdMapping && (_this24.userStore.userKey = !v(t) && k(t).length > 0 ? k(t).slice(0, 1e3) : ""), _this24.userStore.userId = k(e).slice(0, 1e3), _i20 && _i20 !== _this24.userStore.userId && (_this24.userStore.sessionId = "");
      } else _this24.clearUserId(), _this24.callError("setUserId");
    }, _this24.clearUserId = function () {
      _this24.userStore.userId = "", _this24.userStore.userKey = "";
    }, _this24.track = function (e, t, i, n) {
      var r, s;
      ((null === (s = null === (r = _this24.plugins) || void 0 === r ? void 0 : r.gioCustomTracking) || void 0 === s ? void 0 : s.buildCustomEvent) || function () {})(e, Object.assign(Object.assign({}, _this24.dataStore.generalProps), y(t) && !F(t) ? t : {}), i, n);
    }, _this24.sendPage = function (e) {
      return _this24.dataStore.currentPage.buildPageEvent(e);
    }, _this24.sendVisit = function (e) {
      return _this24.dataStore.buildVisitEvent(e);
    }, _this24.trackTimerStart = function (e, t) {
      _this24.vdsConfig.dataCollect && Y(e, function () {
        var i = oe();
        _(t) ? (_this24.dataStore.trackTimers[i] = {
          eventName: e,
          leng: 0,
          start: +Date.now()
        }, t(i)) : z("回调方法不合法，返回timerId失败!");
      });
    }, _this24.trackTimerPause = function (e) {
      if (e && _this24.dataStore.trackTimers[e]) {
        var _t18 = _this24.dataStore.trackTimers[e];
        _t18.start && (_t18.leng = _t18.leng + (+Date.now() - _t18.start)), _t18.start = 0;
      }
    }, _this24.trackTimerResume = function (e) {
      if (e && _this24.dataStore.trackTimers[e]) {
        var _t19 = _this24.dataStore.trackTimers[e];
        0 === _t19.start && (_t19.start = +Date.now());
      }
    }, _this24.trackTimerEnd = function (e, t) {
      if (_this24.vdsConfig.dataCollect) {
        var _i21 = 864e5;
        if (e && _this24.dataStore.trackTimers[e]) {
          var _n11 = _this24.dataStore.trackTimers[e];
          if (0 !== _n11.start) {
            var _e16 = +Date.now() - _n11.start;
            _n11.leng = _e16 > 0 ? _n11.leng + _e16 : 0;
          }
          _this24.track(_n11.eventName, Object.assign(Object.assign({}, t), {
            event_duration: _n11.leng > _i21 ? 0 : _n11.leng / 1e3
          })), _this24.removeTimer(e);
        } else z("未查找到对应的计时器，请检查!", "error");
      }
    }, _this24.removeTimer = function (e) {
      e && _this24.dataStore.trackTimers[e] && delete _this24.dataStore.trackTimers[e];
    }, _this24.clearTrackTimer = function () {
      _this24.dataStore.trackTimers = {};
    }, _this24.dataStore = new di(_assertThisInitialized(_this24));
    return _this24;
  }
  return _createClass(hi);
}(ii);
var ui;
!function () {
  var e, t, i, n, s;
  var o = window.gioCompatibilityVds ? "gdp_vds" : "vds";
  if (null === (e = window[o]) || void 0 === e ? void 0 : e.gioSDKInstalled) return ui = window.gdp, void z("SDK重复加载，请检查是否重复加载SDK或接入其他平台SDK导致冲突!", "warn");
  window[o] = Object.assign(Object.assign({}, null !== (t = window[o]) && void 0 !== t ? t : {}), {
    gioSDKInstalled: !0
  });
  var d = new hi();
  ui = function ui() {
    var e;
    var t = arguments[0];
    if (I(t) && R(r, t) && d[t]) {
      var _e17 = x(L(arguments));
      if ("init" === t) {
        var _t20 = function (e) {
          var t;
          return e.vdsConfig || e.gioSDKInitialized || (null === (t = window.vds) || void 0 === t ? void 0 : t.gioSDKInitialized) ? (z("SDK重复初始化，请检查是否重复加载SDK或接入其他平台SDK导致冲突!", "warn"), !1) : !(R(["", "localhost", "127.0.0.1"], location.hostname) && !window._gr_ignore_local_rule && (z("当前SDK不允许在本地环境初始化!", "warn"), 1));
        }(d);
        if (!_t20) return;
        var _i22 = function (e) {
          return !F(A(e)) || (z('SDK初始化失败，请使用 gdp("init", "您的GrowingIO项目 accountId", "您项目的 dataSourceId", options); 进行初始化!', "error"), !1);
        }(_e17);
        if (!_i22) return;
        var _n12 = function (e) {
          var t = N(e);
          var i = C(e);
          return te(k(t).trim()) ? (y(i) && i || (i = {}), {
            projectId: t,
            userOptions: i
          }) : (z("SDK初始化失败，accountId 参数不合法!", "error"), !1);
        }(_e17);
        if (!_n12) return;
        var _r7 = function (e) {
          var t = e[1],
            i = e[2],
            n = C(e);
          return t && I(t) ? {
            dataSourceId: t,
            appId: I(i) ? i : "",
            cdpOptions: n
          } : (z("SDK初始化失败，dataSourceId 参数不合法!", "error"), !1);
        }(_e17);
        if (!_r7) return;
        var _s4 = _n12.projectId,
          _o2 = _r7.dataSourceId,
          _a3 = _r7.appId,
          _c2 = _r7.cdpOptions;
        d.init(Object.assign(Object.assign({}, _c2), {
          projectId: _s4,
          dataSourceId: _o2,
          appId: _a3
        }));
      } else if ("registerPlugins" === t) d.registerPlugins(_e17[0]);else {
        if (d.gioSDKInitialized && d.vdsConfig) return d[t].apply(d, _toConsumableArray(_e17));
        z("SDK未初始化!", "error");
      }
    } else R(a, t) ? z("\u65B9\u6CD5 ".concat(k(t), " \u5DF2\u88AB\u5F03\u7528\uFF0C\u8BF7\u79FB\u9664!"), "warn") : z("\u4E0D\u5B58\u5728\u540D\u4E3A ".concat(k(t), " \u7684\u65B9\u6CD5\u8C03\u7528!"), "error");
    window[o] = Object.assign(Object.assign({}, window[o]), {
      _gr_ignore_local_rule: null !== (e = window._gr_ignore_local_rule) && void 0 !== e && e,
      gioEnvironment: "cdp",
      gioSDKVersion: d.sdkVersion,
      gioSDKFull: d.gioSDKFull,
      canIUse: function canIUse(e) {
        return R(r, e) && d[e];
      }
    });
  };
  var c = null === (i = null === window || void 0 === window ? void 0 : window.gdp) || void 0 === i ? void 0 : i.q,
    l = null === (n = null === window || void 0 === window ? void 0 : window.gdp) || void 0 === n ? void 0 : n.e,
    h = null === (s = null === window || void 0 === window ? void 0 : window.gdp) || void 0 === s ? void 0 : s.ef;
  window.gdp = ui, window.gdp.e = l, window.gdp.ef = h, S(c) && !F(c) && c.forEach(function (e) {
    ui.apply(null, e);
  });
}();
var gi = ui;
export { gi as default };